export const DashedLines = 
[
  {'multiGeoLine': [[{'latitude': 4.558338126496367,
    'longitude': 34.30475930309329},
   {'latitude': 4.909270508830801, 'longitude': 34.87080583896581},
   {'latitude': 4.558338126496367, 'longitude': 35.2748292673477}],
  [{'latitude': 11.94317591756274, 'longitude': 33.20956840453081},
   {'latitude': 10.482075403813836, 'longitude': 33.16009299621408},
   {'latitude': 10.482288722706627, 'longitude': 33.78866988849777},
   {'latitude': 9.491661532704683, 'longitude': 33.760421116595055},
   {'latitude': 9.49884573080318, 'longitude': 34.1165351678237}],
  [{'latitude': 8.659404284392735, 'longitude': 23.880031974775036},
   {'latitude': 8.659534693103124, 'longitude': 24.577831995103036},
   {'latitude': 10.18510056570598, 'longitude': 24.607347666117285},
   {'latitude': 10.18510056570598, 'longitude': 25.66656239945052},
   {'latitude': 9.532147283910605, 'longitude': 26.515793794522825},
   {'latitude': 9.531286620304938, 'longitude': 29.52690194139292},
   {'latitude': 10.078236843543493, 'longitude': 29.54065010000681},
   {'latitude': 10.093099814134092, 'longitude': 30.491143716715367},
   {'latitude': 9.748537062656979, 'longitude': 30.792877196450696},
   {'latitude': 9.749224602105073, 'longitude': 31.62716112846143},
   {'latitude': 10.779476879707271, 'longitude': 32.44499391724645},
   {'latitude': 11.946616303063065, 'longitude': 32.482906241335236},
   {'latitude': 11.94317591756274, 'longitude': 33.20956840453081}],
  [{'latitude': 21.773513975707388, 'longitude': 33.22915268517912},
   {'latitude': 21.46895494282589, 'longitude': 33.65787875697597},
   {'latitude': 21.564382333452834, 'longitude': 34.03209388710402},
   {'latitude': 21.773535855264115, 'longitude': 34.08820519509683}],
  [{'latitude': 21.773535855264115, 'longitude': 34.08820519509683},
   {'latitude': 22.970252278755364, 'longitude': 36.625594415682485}],
  [{'latitude': 31.094942442021885, 'longitude': 34.167815715887315},
   {'latitude': 31.09450617629625, 'longitude': 33.70373701002512}],
  [{'latitude': 31.495205809705443, 'longitude': 34.21522278395829},
   {'latitude': 31.094942442021885, 'longitude': 34.167815715887315}],
  [{'latitude': 31.35997408759738, 'longitude': 35.20657243919669},
   {'latitude': 31.36034041268766, 'longitude': 34.77144968264022},
   {'latitude': 32.56560804932831, 'longitude': 34.91898512638089},
   {'latitude': 32.56560614077563, 'longitude': 35.354395566359734}],
  [{'latitude': 32.23891058917878, 'longitude': 74.95884843001974},
   {'latitude': 33.83801518624899, 'longitude': 77.32744738500374}],
  [{'latitude': 32.78420490484692, 'longitude': 74.45436660883512},
   {'latitude': 33.33628818442769, 'longitude': 73.94501508580039},
   {'latitude': 34.200728742526714, 'longitude': 73.15015482282838}],
  [{'latitude': 34.200728742526714, 'longitude': 73.15015482282838},
   {'latitude': 36.92462402004956, 'longitude': 73.98930670427355}],
  [{'latitude': 37.59892180959597, 'longitude': 126.47218487613407},
   {'latitude': 38.93461545316242, 'longitude': 128.88444918082715}],
  [{'latitude': 3.982319000252161, 'longitude': 41.91011899909848},
   {'latitude': 3.9837743562952, 'longitude': 42.69579276487875},
   {'latitude': 4.934711015655504, 'longitude': 44.87419746525865},
   {'latitude': 8.04534583530234, 'longitude': 47.921925577665014}]]}
];

export const DottedLines = 
[
  {'multiGeoLine': [[{'latitude': 32.78420490484692,
    'longitude': 74.45436660883512},
   {'latitude': 33.78370078387682, 'longitude': 74.4498101651073},
   {'latitude': 34.66626906630195, 'longitude': 75.83911055279192}]]}
];

export const SolidLines = 
[
  {'multiGeoLine': [[{'latitude': -31.033411994276943,
    'longitude': -55.88587368316382},
   {'latitude': -31.045794834035327, 'longitude': -54.67206711516729},
   {'latitude': -32.95326668438335, 'longitude': -52.76498150999413}],
  [{'latitude': -34.11710282164776, 'longitude': -58.504969603218214},
   {'latitude': -30.117529036627257, 'longitude': -57.676951391971116},
   {'latitude': -29.74593590910834, 'longitude': -57.17168979065752}],
  [{'latitude': -29.74593590910834, 'longitude': -57.17168979065752},
   {'latitude': -31.033411994276943, 'longitude': -55.88587368316382}],
  [{'latitude': -29.709902857843673, 'longitude': 26.888668074788615},
   {'latitude': -30.63861584905567, 'longitude': 28.21179664401663},
   {'latitude': -29.243349316365077, 'longitude': 29.69092825027462}],
  [{'latitude': -29.243349316365077, 'longitude': 29.69092825027462},
   {'latitude': -28.3146363251534, 'longitude': 28.376048119989626},
   {'latitude': -29.709902857843673, 'longitude': 26.888668074788615}],
  [{'latitude': -26.04280593248269, 'longitude': 30.685490269712528},
   {'latitude': -27.064390222347395, 'longitude': 30.765022737480656},
   {'latitude': -27.064390222347395, 'longitude': 32.03204600978016},
   {'latitude': -25.974341298601768, 'longitude': 31.93727983108745}],
  [{'latitude': -25.974341298601768, 'longitude': 31.93727983108745},
   {'latitude': -25.974341298601768, 'longitude': 32.695291427744465}],
  [{'latitude': -25.6964080080256, 'longitude': -54.856020112195424},
   {'latitude': -25.6964080080256, 'longitude': -53.87473128612881},
   {'latitude': -27.454771270512733, 'longitude': -54.11565010441634},
   {'latitude': -29.74593590910834, 'longitude': -57.17168979065752}],
  [{'latitude': -25.671220995171996, 'longitude': 31.91513614074354},
   {'latitude': -25.67132073599815, 'longitude': 31.090807929994828},
   {'latitude': -26.04280593248269, 'longitude': 30.685490269712528}],
  [{'latitude': -25.671220995171996, 'longitude': 31.91513614074354},
   {'latitude': -25.974341298601768, 'longitude': 31.93727983108745}],
  [{'latitude': -28.736073605592267, 'longitude': 16.6508674294615},
   {'latitude': -28.724323023715794, 'longitude': 20.423134540605613},
   {'latitude': -25.059838625076473, 'longitude': 20.24174789913061}],
  [{'latitude': -22.774057797988828, 'longitude': -67.03580336743632},
   {'latitude': -24.8048435370243, 'longitude': -67.30324039236942},
   {'latitude': -24.8048435370243, 'longitude': -67.93690808656665},
   {'latitude': -25.498282570025594, 'longitude': -68.85022902666847},
   {'latitude': -31.293451632003766, 'longitude': -69.99814325012798},
   {'latitude': -31.98689066500505, 'longitude': -69.34354223863878},
   {'latitude': -40.47652393784488, 'longitude': -71.92879524882306},
   {'latitude': -41.450972776135735, 'longitude': -71.10239861558021},
   {'latitude': -43.50487459607152, 'longitude': -71.92221455130431},
   {'latitude': -44.283147493225805, 'longitude': -71.28744843566405},
   {'latitude': -46.8065478529961, 'longitude': -72.39709446578132},
   {'latitude': -47.491164118971625, 'longitude': -71.85489504275091},
   {'latitude': -49.961004036755696, 'longitude': -73.041029857634},
   {'latitude': -52.22658920886523, 'longitude': -71.37598288584576},
   {'latitude': -52.27203357092747, 'longitude': -71.34310465604437},
   {'latitude': -52.27270517069848, 'longitude': -69.06976531715267}],
  [{'latitude': -22.15491580353586, 'longitude': -64.72272363654884},
   {'latitude': -22.15491580353586, 'longitude': -62.201061036984605}],
  [{'latitude': -22.15491580353586, 'longitude': -62.201061036984605},
   {'latitude': -22.873120516988827, 'longitude': -62.285223214210774},
   {'latitude': -24.06187314499078, 'longitude': -61.04859754349304},
   {'latitude': -24.06187314499078, 'longitude': -59.524301219836424},
   {'latitude': -25.300157132024957, 'longitude': -58.23599560780631},
   {'latitude': -27.479536950028837, 'longitude': -58.555087762244355},
   {'latitude': -27.479536950028837, 'longitude': -55.65584513523314},
   {'latitude': -26.934691995995966, 'longitude': -55.57582625721956},
   {'latitude': -26.934691995995966, 'longitude': -55.02576214807203},
   {'latitude': -25.6964080080256, 'longitude': -54.856020112195424}],
  [{'latitude': -21.879312218212732, 'longitude': 31.671660655988283},
   {'latitude': -25.671220995171996, 'longitude': 31.91513614074354}],
  [{'latitude': -25.059838625076473, 'longitude': 20.24174789913061},
   {'latitude': -25.791859221394738, 'longitude': 21.129877476498518},
   {'latitude': -26.657423507913837, 'longitude': 21.175286727014985},
   {'latitude': -26.657423507913837, 'longitude': 22.71602755496317},
   {'latitude': -25.874293915304456, 'longitude': 22.67183006900378},
   {'latitude': -25.874293915304456, 'longitude': 23.488756082043217},
   {'latitude': -25.874293915304456, 'longitude': 25.410934936061057},
   {'latitude': -25.008729628785666, 'longitude': 25.35923347694907},
   {'latitude': -21.87621125928565, 'longitude': 28.828206686668377}],
  [{'latitude': -21.87621125928565, 'longitude': 28.828206686668377},
   {'latitude': -21.879312218212732, 'longitude': 31.671660655988283}],
  [{'latitude': -22.774057797988828, 'longitude': -67.03580336743632},
   {'latitude': -22.774057797988828, 'longitude': -66.80629436979144},
   {'latitude': -21.511008130502344, 'longitude': -66.64952162480775},
   {'latitude': -21.511008130502344, 'longitude': -65.39018434600158},
   {'latitude': -22.15491580353586, 'longitude': -64.72272363654884}],
  [{'latitude': -19.95077030601586, 'longitude': -57.930826415153405},
   {'latitude': -21.981556045987535, 'longitude': -58.1419633634096},
   {'latitude': -21.981556045987535, 'longitude': -56.39455490422116},
   {'latitude': -21.981556045987535, 'longitude': -55.821634098196114},
   {'latitude': -22.82358915702105, 'longitude': -55.90987842064194},
   {'latitude': -24.01234178502299, 'longitude': -54.65846005937354},
   {'latitude': -25.6964080080256, 'longitude': -54.856020112195424}],
  [{'latitude': -22.15491580353586, 'longitude': -62.201061036984605},
   {'latitude': -19.207799913982335, 'longitude': -61.872903160297206},
   {'latitude': -19.207799913982335, 'longitude': -58.708950440699354},
   {'latitude': -19.95077030601586, 'longitude': -57.930826415153405}],
  [{'latitude': -18.712486318981693, 'longitude': -68.11398778895717},
   {'latitude': -22.774057797988828, 'longitude': -68.61367772651595},
   {'latitude': -22.774057797988828, 'longitude': -67.03580336743632}],
  [{'latitude': -25.059838625076473, 'longitude': 20.24174789913061},
   {'latitude': -21.958645953195056, 'longitude': 20.108365816877598},
   {'latitude': -21.958645953195056, 'longitude': 20.775793187689278},
   {'latitude': -21.38160309582794, 'longitude': 20.753848109873726},
   {'latitude': -18.249084726327606, 'longitude': 20.63995385926053},
   {'latitude': -18.249084726327606, 'longitude': 22.487059320004686},
   {'latitude': -18.57882350196618, 'longitude': 23.257672389130953},
   {'latitude': -17.754476561933995, 'longitude': 24.882415861360997}],
  [{'latitude': -17.754476561933995, 'longitude': 24.882415861360997},
   {'latitude': -21.87621125928565, 'longitude': 28.828206686668377}],
  [{'latitude': -18.30633723352193, 'longitude': -70.18394360459037},
   {'latitude': -17.598030729527743, 'longitude': -69.26831110210178}],
  [{'latitude': -17.598030729527743, 'longitude': -69.26831110210178},
   {'latitude': -18.712486318981693, 'longitude': -68.11398778895717}],
  [{'latitude': -17.301085745899407, 'longitude': 22.925680085210715},
   {'latitude': -17.301085745899407, 'longitude': 24.01333838155335},
   {'latitude': -17.754476561933995, 'longitude': 24.882415861360997}],
  [{'latitude': -17.259868398476282, 'longitude': 18.81028513893472},
   {'latitude': -17.754476561933995, 'longitude': 19.913451362786187},
   {'latitude': -17.754476561933995, 'longitude': 21.948360633508276},
   {'latitude': -17.301085745899407, 'longitude': 22.925680085210715}],
  [{'latitude': -17.25285058797205, 'longitude': 11.787179266204173},
   {'latitude': -17.259868398476282, 'longitude': 18.81028513893472}],
  [{'latitude': -16.874276674370854, 'longitude': 32.56816912791366},
   {'latitude': -20.860971652436074, 'longitude': 32.78873194102187},
   {'latitude': -21.879312218212732, 'longitude': 31.671660655988283}],
  [{'latitude': -17.754476561933995, 'longitude': 24.882415861360997},
   {'latitude': -17.754476561933995, 'longitude': 27.201265960480978},
   {'latitude': -15.878187869625714, 'longitude': 29.27227565176033},
   {'latitude': -15.877602929620176, 'longitude': 30.28795362147543}],
  [{'latitude': -15.877602929620176, 'longitude': 30.28795362147543},
   {'latitude': -15.877602929620176, 'longitude': 31.404227234627957},
   {'latitude': -16.874276674370854, 'longitude': 32.56816912791366}],
  [{'latitude': -15.877602929620176, 'longitude': 30.28795362147543},
   {'latitude': -15.05597794966291, 'longitude': 30.263455422144816},
   {'latitude': -14.013821702089047, 'longitude': 33.25851205113899}],
  [{'latitude': -13.486927891488705, 'longitude': -62.374582264869595},
   {'latitude': -13.486927891488705, 'longitude': -60.45246675465166},
   {'latitude': -16.186386984009356, 'longitude': -60.66653179789006},
   {'latitude': -16.186386984009356, 'longitude': -58.68087699290631},
   {'latitude': -17.2513112134952, 'longitude': -58.77491902601545},
   {'latitude': -17.2513112134952, 'longitude': -57.66685268827076},
   {'latitude': -19.95077030601586, 'longitude': -57.930826415153405}],
  [{'latitude': -14.013821702089047, 'longitude': 33.25851205113899},
   {'latitude': -14.599260518078909, 'longitude': 33.28156921079483},
   {'latitude': -14.599260518078909, 'longitude': 34.19781031937868},
   {'latitude': -16.088142922673896, 'longitude': 34.273144316198135},
   {'latitude': -17.047611238837632, 'longitude': 35.185941932097045},
   {'latitude': -15.964270211854197, 'longitude': 35.12947583968246},
   {'latitude': -15.964270211854197, 'longitude': 35.6752769833626},
   {'latitude': -14.187590927937277, 'longitude': 35.590876865625624},
   {'latitude': -13.47258585091403, 'longitude': 34.6946472795596},
   {'latitude': -11.587572464673313, 'longitude': 34.62495952416158}],
  [{'latitude': -11.587572464673313, 'longitude': 34.62495952416158},
   {'latitude': -11.587572464673313, 'longitude': 38.226443701287586}],
  [{'latitude': -17.301085745899407, 'longitude': 22.925680085210715},
   {'latitude': -16.22943472413869, 'longitude': 21.991604191784198},
   {'latitude': -12.973264314242028, 'longitude': 21.89965783767586},
   {'latitude': -12.988471486063666, 'longitude': 23.921745101025838},
   {'latitude': -11.365787781600783, 'longitude': 23.881042889472855}],
  [{'latitude': -17.598030729527743, 'longitude': -69.26831110210178},
   {'latitude': -11.852393027517682, 'longitude': -68.75180108666434},
   {'latitude': -10.936062877000264, 'longitude': -69.73258131118179}],
  [{'latitude': -11.587572464673313, 'longitude': 38.226443701287586},
   {'latitude': -10.439230975546254, 'longitude': 40.60039451018591}],
  [{'latitude': -10.936062877000264, 'longitude': -69.73258131118179},
   {'latitude': -10.936062877000264, 'longitude': -68.12575433943024},
   {'latitude': -10.193092484030863, 'longitude': -67.23436570040111},
   {'latitude': -10.193092484030863, 'longitude': -65.91033796184104},
   {'latitude': -13.486927891488705, 'longitude': -62.374582264869595}],
  [{'latitude': -9.919227283080826, 'longitude': 34.56976974336978},
   {'latitude': -11.587572464673313, 'longitude': 34.62495952416158}],
  [{'latitude': -9.388156993168337, 'longitude': 123.9705789214148},
   {'latitude': -9.590502123892215, 'longitude': 124.29668967688701},
   {'latitude': -9.179722781325454, 'longitude': 124.78736851673865},
   {'latitude': -9.373410566903287, 'longitude': 125.00351051026671}],
  [{'latitude': -14.013821702089047, 'longitude': 33.25851205113899},
   {'latitude': -9.550891334056216, 'longitude': 33.10619365092186},
   {'latitude': -9.302268844993336, 'longitude': 33.09976470984275}],
  [{'latitude': -9.302268844993336, 'longitude': 33.09976470984275},
   {'latitude': -9.919227283080826, 'longitude': 34.56976974336978}],
  [{'latitude': -8.456914245012895, 'longitude': 31.088805821088474},
   {'latitude': -9.302268844993336, 'longitude': 33.09976470984275}],
  [{'latitude': -11.365787781600783, 'longitude': 23.881042889472855},
   {'latitude': -11.365787781600783, 'longitude': 24.06842801005545},
   {'latitude': -11.365787781600783, 'longitude': 27.166192484993456},
   {'latitude': -12.808394925487011, 'longitude': 28.852642744923653},
   {'latitude': -12.808394925487011, 'longitude': 29.839790078616822},
   {'latitude': -12.231352068119888, 'longitude': 29.821037262815498},
   {'latitude': -11.159701047295059, 'longitude': 28.568515994260313},
   {'latitude': -9.511007168167534, 'longitude': 28.52694860539323},
   {'latitude': -8.439356147342705, 'longitude': 29.721391180437156},
   {'latitude': -8.456914245012895, 'longitude': 31.088805821088474}],
  [{'latitude': -6.089967370451107, 'longitude': 11.95885622570573},
   {'latitude': -6.089967369515533, 'longitude': 16.587287517590745}],
  [{'latitude': -6.089967369515533, 'longitude': 16.587287517590745},
   {'latitude': -7.944747983884995, 'longitude': 16.605965779452127},
   {'latitude': -7.944747983884995, 'longitude': 19.22701646613002},
   {'latitude': -6.70822757430514, 'longitude': 19.212063481929302},
   {'latitude': -6.70822757430514, 'longitude': 21.690771530694498},
   {'latitude': -10.912396965566206, 'longitude': 21.75904365462098},
   {'latitude': -10.912396965566206, 'longitude': 23.870231245742527},
   {'latitude': -11.365787781600783, 'longitude': 23.881042889472855}],
  [{'latitude': -4.930101317375134, 'longitude': 13.363710578181811},
   {'latitude': -5.648847815455512, 'longitude': 11.741311706501168}],
  [{'latitude': -8.456914245012895, 'longitude': 31.088805821088474},
   {'latitude': -7.202835737762856, 'longitude': 31.05363588279868},
   {'latitude': -6.890173247149959, 'longitude': 30.087554678852555},
   {'latitude': -4.527801903191531, 'longitude': 30.04603282444687}],
  [{'latitude': -4.100735265988257, 'longitude': -70.2321830791058},
   {'latitude': -4.100735265988257, 'longitude': -70.98988191307737},
   {'latitude': -6.15628668547572, 'longitude': -73.39538443450688},
   {'latitude': -8.806214418028587, 'longitude': -73.52005489375239},
   {'latitude': -10.168326804515075, 'longitude': -72.05000258055078},
   {'latitude': -10.168326804515075, 'longitude': -70.72600370124914},
   {'latitude': -10.936062877000264, 'longitude': -70.77560934469156},
   {'latitude': -10.936062877000264, 'longitude': -69.73258131118179}],
  [{'latitude': -4.779853735481725, 'longitude': 11.313054683080734},
   {'latitude': -4.051469026342644, 'longitude': 12.929162099382737},
   {'latitude': -4.930101317375134, 'longitude': 13.363710578181811}],
  [{'latitude': -4.967534057473771, 'longitude': -78.4049746776748},
   {'latitude': -4.967534057473771, 'longitude': -79.94911560641947},
   {'latitude': -3.794104801162384, 'longitude': -81.23252438459375}],
  [{'latitude': -3.662237616672428, 'longitude': 31.014712273971146},
   {'latitude': -4.527801903191531, 'longitude': 30.04603282444687}],
  [{'latitude': -4.527801903191531, 'longitude': 30.04603282444687},
   {'latitude': -3.703454964095557, 'longitude': 29.100670964869337},
   {'latitude': -2.673021289757641, 'longitude': 29.089959086547026}],
  [{'latitude': -2.673021289757641, 'longitude': 29.089959086547026},
   {'latitude': -2.672984208237707, 'longitude': 31.003316286598054}],
  [{'latitude': -2.672984208237707, 'longitude': 31.003316286598054},
   {'latitude': -3.662237616672428, 'longitude': 31.014712273971146}],
  [{'latitude': -2.416669042985333, 'longitude': -72.76920256878097},
   {'latitude': -2.416669042985333, 'longitude': -70.83405165026016},
   {'latitude': -3.531124631503388, 'longitude': -70.86036354533591},
   {'latitude': -4.100735265988257, 'longitude': -70.2321830791058}],
  [{'latitude': -2.673021289757641, 'longitude': 29.089959086547026},
   {'latitude': -1.108775064011595, 'longitude': 29.0633777079499}],
  [{'latitude': -1.108775064011595, 'longitude': 29.0633777079499},
   {'latitude': -1.102668386581307, 'longitude': 30.97537834955848}],
  [{'latitude': -1.102668386581307, 'longitude': 30.97537834955848},
   {'latitude': -2.672984208237707, 'longitude': 31.003316286598054}],
  [{'latitude': -1.102668386581307, 'longitude': 30.97537834955848},
   {'latitude': -1.088236856513376, 'longitude': 34.04729438786785}],
  [{'latitude': -1.088236856513376, 'longitude': 34.04729438786785},
   {'latitude': -3.01005360511688, 'longitude': 37.63037136440695},
   {'latitude': -3.426117024917659, 'longitude': 37.63601812249349},
   {'latitude': -4.753557459519867, 'longitude': 39.43308304219431}],
  [{'latitude': 0.183727330535319, 'longitude': -75.68937779016274},
   {'latitude': -1.302213454467278, 'longitude': -75.69642303921408},
   {'latitude': -2.144246565500793, 'longitude': -75.70872792627871},
   {'latitude': -3.233936474502741, 'longitude': -76.9679179995537},
   {'latitude': -3.233936474502741, 'longitude': -78.34251120968383},
   {'latitude': -4.967534057473771, 'longitude': -78.4049746776748}],
  [{'latitude': 0.183727330535319, 'longitude': -75.68937779016274},
   {'latitude': -2.416669042985333, 'longitude': -72.76920256878097}],
  [{'latitude': 1.091654508803827, 'longitude': 11.297624058291124},
   {'latitude': 1.091654508803827, 'longitude': 9.445735055425061}],
  [{'latitude': 1.363399075717169, 'longitude': -79.04999224004284},
   {'latitude': 1.372479958537269, 'longitude': -77.04311344365512},
   {'latitude': 0.183727330535319, 'longitude': -75.68937779016274}],
  [{'latitude': 1.744956906891559, 'longitude': 34.903297272586705},
   {'latitude': 0.080703227688446, 'longitude': 34.04504883817217},
   {'latitude': -1.088236856513376, 'longitude': 34.04729438786785}],
  [{'latitude': 1.867793553537921, 'longitude': -56.19243847764682},
   {'latitude': 1.867793553537921, 'longitude': -54.251916484712105},
   {'latitude': 1.867793553537921, 'longitude': -53.971496770300675}],
  [{'latitude': -4.100735265988257, 'longitude': -70.2321830791058},
   {'latitude': -4.100735265988257, 'longitude': -69.39029548556834},
   {'latitude': -0.831665538982733, 'longitude': -69.32763609975275},
   {'latitude': -0.113460826465328, 'longitude': -70.13805966689718},
   {'latitude': 1.917324913506349, 'longitude': -70.15245093557452},
   {'latitude': 1.917324913506349, 'longitude': -67.71277380537582},
   {'latitude': 1.422011318505056, 'longitude': -67.14570783403916}],
  [{'latitude': 2.21229824720144, 'longitude': 13.299734362648941},
   {'latitude': 1.120710193280808, 'longitude': 13.29395259669706},
   {'latitude': 1.120710193280808, 'longitude': 14.46911512077564},
   {'latitude': -1.245911264175881, 'longitude': 14.469355227436424},
   {'latitude': -1.972505571289602, 'longitude': 14.471250476682076},
   {'latitude': -1.972505571289602, 'longitude': 11.180309803175279},
   {'latitude': -1.972505571289602, 'longitude': 10.639655263956325},
   {'latitude': -3.417497383747233, 'longitude': 10.64238842161337}],
  [{'latitude': 2.21229824720144, 'longitude': 13.299734362648941},
   {'latitude': 2.210528565000018, 'longitude': 16.135009001114344}],
  [{'latitude': 2.21354643028441, 'longitude': 9.448732674213108},
   {'latitude': 2.21354643028441, 'longitude': 11.299970680278056}],
  [{'latitude': 2.21354643028441, 'longitude': 11.299970680278056},
   {'latitude': 1.091654508803827, 'longitude': 11.297624058291124}],
  [{'latitude': 2.21354643028441, 'longitude': 11.299970680278056},
   {'latitude': 2.21229824720144, 'longitude': 13.299734362648941}],
  [{'latitude': 2.470091915429861, 'longitude': 17.84167865492966},
   {'latitude': -0.873766667927427, 'longitude': 17.831457690656123},
   {'latitude': -2.328748770250506, 'longitude': 16.197210429468893},
   {'latitude': -4.131528656221167, 'longitude': 16.199198747962793},
   {'latitude': -4.930101317375134, 'longitude': 13.363710578181811}],
  [{'latitude': 2.210528565000018, 'longitude': 16.135009001114344},
   {'latitude': 3.46864821749442, 'longitude': 17.05519827591632},
   {'latitude': 3.46864821749442, 'longitude': 18.514078853808225}],
  [{'latitude': 3.46864821749442, 'longitude': 18.514078853808225},
   {'latitude': 2.470091915429861, 'longitude': 17.84167865492966}],
  [{'latitude': -1.108775064011595, 'longitude': 29.0633777079499},
   {'latitude': 0.665583814984956, 'longitude': 29.07904093852285},
   {'latitude': 1.411589779064997, 'longitude': 30.5100643371286},
   {'latitude': 3.607336024094679, 'longitude': 30.54591234695503}],
  [{'latitude': 3.982319000252161, 'longitude': 41.91011899909848},
   {'latitude': 3.171460060493771, 'longitude': 40.976308480374286},
   {'latitude': -0.810861243312857, 'longitude': 40.954736235725164},
   {'latitude': -1.664949852534576, 'longitude': 41.564500252271856}],
  [{'latitude': 3.607336024094679, 'longitude': 30.54591234695503},
   {'latitude': 3.607336024094679, 'longitude': 33.44138841650773},
   {'latitude': 3.991071232004941, 'longitude': 33.789395382901944}],
  [{'latitude': 3.991071232004941, 'longitude': 33.789395382901944},
   {'latitude': 1.744956906891559, 'longitude': 34.903297272586705}],
  [{'latitude': 0.509451068505484, 'longitude': 109.11646935300618},
   {'latitude': 0.521051226674558, 'longitude': 111.69916784561603},
   {'latitude': 1.691229595507692, 'longitude': 113.0403000649298},
   {'latitude': 1.691229595507692, 'longitude': 115.64811161659817},
   {'latitude': 4.068734851511591, 'longitude': 115.73688252523236},
   {'latitude': 4.063646096240348, 'longitude': 117.6976665199552}],
  [{'latitude': 4.271056241863887, 'longitude': 37.45889622044696},
   {'latitude': 3.726211286894809, 'longitude': 38.067031677803314},
   {'latitude': 3.726211286894809, 'longitude': 39.86276348266271},
   {'latitude': 3.9837743562952, 'longitude': 40.31618329251941},
   {'latitude': 3.982319000252161, 'longitude': 41.91011899909848}],
  [{'latitude': 4.393892888510251, 'longitude': -59.38012177969181},
   {'latitude': 4.121470411026032, 'longitude': -59.68109558051533},
   {'latitude': 1.867793553537921, 'longitude': -59.63597499123696},
   {'latitude': 1.867793553537921, 'longitude': -57.25240742350914},
   {'latitude': 1.867793553537921, 'longitude': -56.19243847764682}],
  [{'latitude': 4.439462863696237, 'longitude': 27.72817784770681},
   {'latitude': 4.439462863696237, 'longitude': 29.614311891811237},
   {'latitude': 3.607336024094679, 'longitude': 30.54591234695503}],
  [{'latitude': 3.548655576058621, 'longitude': 114.78533073214516},
   {'latitude': 3.548655576058621, 'longitude': 113.69113587332876},
   {'latitude': 4.47646778100392, 'longitude': 113.73804909800577}],
  [{'latitude': 3.991071232004941, 'longitude': 33.789395382901944},
   {'latitude': 4.558338126496367, 'longitude': 34.30475930309329}],
  [{'latitude': 4.558338126496367, 'longitude': 34.30475930309329},
   {'latitude': 4.558338126496367, 'longitude': 35.2748292673477}],
  [{'latitude': 4.558338126496367, 'longitude': 35.2748292673477},
   {'latitude': 4.558338126496367, 'longitude': 35.994749091976324}],
  [{'latitude': 4.558338126496367, 'longitude': 35.994749091976324},
   {'latitude': 4.558338126496367, 'longitude': 37.13862109641033},
   {'latitude': 4.271056241863887, 'longitude': 37.45889622044696}],
  [{'latitude': 1.867793553537921, 'longitude': -53.971496770300675},
   {'latitude': 1.867793553537921, 'longitude': -52.20485257364209},
   {'latitude': 4.047173371541817, 'longitude': -52.242573529263616},
   {'latitude': 4.591109738485599, 'longitude': -51.640442391725294}],
  [{'latitude': 1.422011318505056, 'longitude': -67.14570783403916},
   {'latitude': 0.889549203294351, 'longitude': -66.53826824356187},
   {'latitude': 0.889549203294351, 'longitude': -64.09898526386178},
   {'latitude': 3.923344973025706, 'longitude': -64.15144261426929},
   {'latitude': 3.923344973025706, 'longitude': -62.678256865050805},
   {'latitude': 4.33197868878441, 'longitude': -62.22702111430474},
   {'latitude': 4.344361528542464, 'longitude': -60.7258565263572},
   {'latitude': 5.161628960996084, 'longitude': -60.75107653808114}],
  [{'latitude': 5.161628960996084, 'longitude': -60.75107653808114},
   {'latitude': 5.161628960996084, 'longitude': -60.273975675136285},
   {'latitude': 4.393892888510251, 'longitude': -59.38012177969181}],
  [{'latitude': 3.46864821749442, 'longitude': 18.514078853808225},
   {'latitude': 4.419650319896107, 'longitude': 18.521865138346183},
   {'latitude': 5.115319247121874, 'longitude': 19.53257750447489},
   {'latitude': 4.419650319896107, 'longitude': 20.553992850496034},
   {'latitude': 4.419650319896107, 'longitude': 22.99016253638513},
   {'latitude': 5.212152071897407, 'longitude': 23.695844473613445},
   {'latitude': 5.212152071897407, 'longitude': 27.739161244847832}],
  [{'latitude': 5.212152071897407, 'longitude': 27.739161244847832},
   {'latitude': 4.439462863696237, 'longitude': 27.72817784770681}],
  [{'latitude': 5.44213352959602, 'longitude': 114.88734638614683},
   {'latitude': 3.548655576058621, 'longitude': 114.78533073214516}],
  [{'latitude': 1.867793553537921, 'longitude': -56.19243847764682},
   {'latitude': 2.023464459312833, 'longitude': -56.3706159337},
   {'latitude': 2.617840773313489, 'longitude': -57.05246192065539},
   {'latitude': 5.837379141287117, 'longitude': -57.134004280420484}],
  [{'latitude': 5.841648005214423, 'longitude': -54.0591844811572},
   {'latitude': 1.867793553537921, 'longitude': -53.971496770300675}],
  [{'latitude': 2.210528565000018, 'longitude': 16.135009001114344},
   {'latitude': 2.840840618421012, 'longitude': 16.136191507444423},
   {'latitude': 3.99753850044348, 'longitude': 14.828832969041336},
   {'latitude': 6.958597504707812, 'longitude': 14.851787002216474},
   {'latitude': 7.527470000169172, 'longitude': 15.50747999802869}],
  [{'latitude': 7.820173040851159, 'longitude': -8.61571114874585},
   {'latitude': 7.547130970823904, 'longitude': -8.924210653674365},
   {'latitude': 6.645939099839139, 'longitude': -7.896767953517149},
   {'latitude': 4.503309448091954, 'longitude': -7.887921489579548}],
  [{'latitude': 5.161628960996084, 'longitude': -60.75107653808114},
   {'latitude': 7.241946059999337, 'longitude': -60.820552524708816},
   {'latitude': 8.145047265131852, 'longitude': -59.83085060396097}],
  [{'latitude': 8.43843750922993, 'longitude': -76.96654797269478},
   {'latitude': 7.511685545953168, 'longitude': -77.97688337194401}],
  [{'latitude': 8.659290828009887, 'longitude': 23.272940049663347},
   {'latitude': 8.659404284392735, 'longitude': 23.880031974775036}],
  [{'latitude': 8.659404284392735, 'longitude': 23.880031974775036},
   {'latitude': 5.212152071897407, 'longitude': 27.739161244847832}],
  [{'latitude': 7.055263124739853, 'longitude': -12.053995419377841},
   {'latitude': 8.803259808297314, 'longitude': -10.09050342683512}],
  [{'latitude': 8.803259808297314, 'longitude': -10.09050342683512},
   {'latitude': 7.820173040851159, 'longitude': -8.61571114874585}],
  [{'latitude': 9.450765128192838, 'longitude': -82.63460028421028},
   {'latitude': 8.47060800578653, 'longitude': -83.68750383329451}],
  [{'latitude': 9.49884573080318, 'longitude': 34.1165351678237},
   {'latitude': 8.560471974103123, 'longitude': 34.096889770579935},
   {'latitude': 7.686813549842527, 'longitude': 33.6080808472531},
   {'latitude': 4.620000000409164, 'longitude': 35.94769999933001},
   {'latitude': 4.558338126496367, 'longitude': 35.994749091976324}],
  [{'latitude': 9.772523141974288, 'longitude': 3.839202305140616},
   {'latitude': 9.055247978799981, 'longitude': 3.021901763762094},
   {'latitude': 5.744747229789623, 'longitude': 3.016143920729295}],
  [{'latitude': 9.956439849785072, 'longitude': 14.883496152880813},
   {'latitude': 9.95433297061858, 'longitude': 14.173690440733402},
   {'latitude': 8.724181162270382, 'longitude': 14.163691203312595},
   {'latitude': 7.527470000169172, 'longitude': 15.50747999802869}],
  [{'latitude': 8.202940068780439, 'longitude': -13.934612890746306},
   {'latitude': 10.010578219773052, 'longitude': -11.906664003376944},
   {'latitude': 8.803259808297314, 'longitude': -10.09050342683512}],
  [{'latitude': 10.177008407654503, 'longitude': -2.934160720592993},
   {'latitude': 5.053655500225389, 'longitude': -2.921091327682162}],
  [{'latitude': 10.177139900280563, 'longitude': -5.280662285007891},
   {'latitude': 10.177008407654503, 'longitude': -2.934160720592993}],
  [{'latitude': 7.820173040851159, 'longitude': -8.61571114874585},
   {'latitude': 8.448322841808672, 'longitude': -7.905956750017951},
   {'latitude': 10.692106682898054, 'longitude': -7.920277878210129}],
  [{'latitude': 10.692106682898054, 'longitude': -7.920277878210129},
   {'latitude': 10.699999998601832, 'longitude': -6.233309998472911},
   {'latitude': 10.177139900280563, 'longitude': -5.280662285007891}],
  [{'latitude': 7.527470000169172, 'longitude': 15.50747999802869},
   {'latitude': 7.528753904728802, 'longitude': 17.10965943499427},
   {'latitude': 9.31968378156487, 'longitude': 19.16647187339987},
   {'latitude': 9.31968378156487, 'longitude': 20.29705263983165},
   {'latitude': 10.797420804523693, 'longitude': 22.00449989859319},
   {'latitude': 10.797721182055506, 'longitude': 23.319811506593762}],
  [{'latitude': 10.797721182055506, 'longitude': 23.319811506593762},
   {'latitude': 8.659290828009887, 'longitude': 23.272940049663347}],
  [{'latitude': 8.04534583530234, 'longitude': 47.921925577665014},
   {'latitude': 8.04534583530234, 'longitude': 46.076948136023574},
   {'latitude': 9.33316118230429, 'longitude': 43.19247300467375},
   {'latitude': 10.954482657606023, 'longitude': 43.25314120783814},
   {'latitude': 10.962172394681284, 'longitude': 43.253458094373954}],
  [{'latitude': 10.962172394681284, 'longitude': 43.253458094373954},
   {'latitude': 10.964640687620602, 'longitude': 44.06838862155688}],
  [{'latitude': 10.177008407654503, 'longitude': -2.934160720592993},
   {'latitude': 11.133506782953475, 'longitude': -2.940202183980254},
   {'latitude': 11.133506782953475, 'longitude': -0.134432653533181}],
  [{'latitude': 11.133506782953475, 'longitude': -0.134432653533181},
   {'latitude': 5.457199331868311, 'longitude': -0.133892227495657}],
  [{'latitude': 11.133506782953475, 'longitude': -0.134432653533181},
   {'latitude': 11.133506782953475, 'longitude': 0.975312012313495}],
  [{'latitude': 11.133506782953475, 'longitude': 0.975312012313495},
   {'latitude': 5.744747229789623, 'longitude': 0.971532064549119}],
  [{'latitude': 10.459237949278375, 'longitude': -86.08239802517232},
   {'latitude': 11.219171920644795, 'longitude': -85.27859622544541},
   {'latitude': 11.219171920644795, 'longitude': -84.44686419826566},
   {'latitude': 10.926971151280148, 'longitude': -84.09058499327314},
   {'latitude': 10.926935799532698, 'longitude': -83.21022228551277}],
  [{'latitude': 1.422011318505056, 'longitude': -67.14570783403916},
   {'latitude': 6.028427751545067, 'longitude': -67.26666121240523},
   {'latitude': 6.028427751545067, 'longitude': -69.79477719573482},
   {'latitude': 7.118117660547016, 'longitude': -69.83848832694964},
   {'latitude': 7.118117660547016, 'longitude': -73.15520518017291},
   {'latitude': 9.619451316003875, 'longitude': -73.2843164468312},
   {'latitude': 11.328799193228743, 'longitude': -71.44500274354047}],
  [{'latitude': 11.133506782953475, 'longitude': 0.975312012313495},
   {'latitude': 11.133506782953475, 'longitude': 1.603469369415033},
   {'latitude': 11.500150973759132, 'longitude': 2.083946454843507}],
  [{'latitude': 4.346418359451257, 'longitude': 8.912030413401114},
   {'latitude': 5.928663937600406, 'longitude': 8.919067194623068},
   {'latitude': 7.289647579515162, 'longitude': 10.470886530858568},
   {'latitude': 6.793072466835708, 'longitude': 11.03119993190922},
   {'latitude': 8.558672867056742, 'longitude': 13.049746172293096},
   {'latitude': 10.655323341148913, 'longitude': 13.071909556056118},
   {'latitude': 12.255398703497848, 'longitude': 14.916449538394238}],
  [{'latitude': 12.255398703497848, 'longitude': 14.916449538394238},
   {'latitude': 9.956439849785072, 'longitude': 14.883496152880813}],
  [{'latitude': 12.368919777136181, 'longitude': -16.3141005374332},
   {'latitude': 12.368919777136181, 'longitude': -12.535033791462654}],
  [{'latitude': 12.368919777136181, 'longitude': -12.535033791462654},
   {'latitude': 10.71046117209889, 'longitude': -12.514229785276482},
   {'latitude': 10.714581690290501, 'longitude': -15.110065916696396}],
  [{'latitude': 12.368919777136181, 'longitude': -12.535033791462654},
   {'latitude': 12.368919777136181, 'longitude': -11.333774451115545}],
  [{'latitude': 12.368919777136181, 'longitude': -11.333774451115545},
   {'latitude': 12.368919777136181, 'longitude': -9.462960725902196},
   {'latitude': 10.692106682898054, 'longitude': -7.920277878210129}],
  [{'latitude': 12.443290777478637, 'longitude': 42.41576507698548},
   {'latitude': 12.439969553426375, 'longitude': 43.3239816888003}],
  [{'latitude': 10.962172394681284, 'longitude': 43.253458094373954},
   {'latitude': 10.957789773907152, 'longitude': 41.809696554099915},
   {'latitude': 12.443730558909746, 'longitude': 41.87286377970223},
   {'latitude': 12.443290777478637, 'longitude': 42.41576507698548}],
  [{'latitude': 12.514660971570564, 'longitude': 108.32290007089065},
   {'latitude': 10.144949798704916, 'longitude': 104.8541777348915}],
  [{'latitude': 11.500150973759132, 'longitude': 2.083946454843507},
   {'latitude': 12.851689792752696, 'longitude': 3.857357195142787}],
  [{'latitude': 12.851689792752696, 'longitude': 3.857357195142787},
   {'latitude': 9.772523141974288, 'longitude': 3.839202305140616}],
  [{'latitude': 12.921739312461009, 'longitude': -12.582073053469081},
   {'latitude': 12.921739312461009, 'longitude': -16.323992126119812}],
  [{'latitude': 13.560936899595289, 'longitude': -16.336368316305073},
   {'latitude': 13.560936899595289, 'longitude': -12.591359889736653},
   {'latitude': 12.921739312461009, 'longitude': -12.582073053469081}],
  [{'latitude': 12.851689792752696, 'longitude': 3.857357195142787},
   {'latitude': 13.772663364617053, 'longitude': 5.068166345306345},
   {'latitude': 13.77284362127625, 'longitude': 13.484058437017595}],
  [{'latitude': 13.77284362127625, 'longitude': 13.484058437017595},
   {'latitude': 12.255398703497848, 'longitude': 14.916449538394238}],
  [{'latitude': 9.49884573080318, 'longitude': 34.1165351678237},
   {'latitude': 10.759664335907148, 'longitude': 34.15805909617114},
   {'latitude': 12.384292927510003, 'longitude': 36.06581948879476},
   {'latitude': 13.573045555511953, 'longitude': 36.11432808885631},
   {'latitude': 14.246672044713124, 'longitude': 36.91344122713758}],
  [{'latitude': 14.246672044713124, 'longitude': 36.91344122713758},
   {'latitude': 14.246672044713124, 'longitude': 39.49370957535782},
   {'latitude': 14.246672044713124, 'longitude': 40.31703989498971},
   {'latitude': 12.443290777478637, 'longitude': 42.41576507698548}],
  [{'latitude': 13.548518345848349, 'longitude': -89.97696692821839},
   {'latitude': 14.34661618926327, 'longitude': -89.14859128693615}],
  [{'latitude': 14.34661618926327, 'longitude': -89.14859128693615},
   {'latitude': 14.351404084950236, 'longitude': -87.28304782937526},
   {'latitude': 13.548518345848349, 'longitude': -87.20210896590979}],
  [{'latitude': 11.687716948273774, 'longitude': 102.80784389337835},
   {'latitude': 12.067817400657715, 'longitude': 102.84817229463688},
   {'latitude': 14.592483574583564, 'longitude': 103.15043570000118},
   {'latitude': 14.592483574583564, 'longitude': 104.8612758203224}],
  [{'latitude': 14.592483574583564, 'longitude': 104.8612758203224},
   {'latitude': 14.592483574583564, 'longitude': 107.05727955661466}],
  [{'latitude': 14.592483574583564, 'longitude': 107.05727955661466},
   {'latitude': 14.592483574583564, 'longitude': 108.58937518571524},
   {'latitude': 12.514660971570564, 'longitude': 108.32290007089065}],
  [{'latitude': 13.280810678375019, 'longitude': -87.17452979577057},
   {'latitude': 13.280810678375019, 'longitude': -86.35521856180442},
   {'latitude': 14.660647642792313, 'longitude': -84.92356405816012},
   {'latitude': 14.660912719121843, 'longitude': -83.55744112639567}],
  [{'latitude': 14.989669999839558, 'longitude': 0.229350000634471},
   {'latitude': 12.758573815601082, 'longitude': 2.088009730981558},
   {'latitude': 11.500150973759132, 'longitude': 2.083946454843507}],
  [{'latitude': 10.177139900280563, 'longitude': -5.280662285007891},
   {'latitude': 11.869173616066462, 'longitude': -5.289205272079501},
   {'latitude': 14.989752451369961, 'longitude': -1.629391878945749},
   {'latitude': 14.989669999839558, 'longitude': 0.229350000634471}],
  [{'latitude': 14.34661618926327, 'longitude': -89.14859128693615},
   {'latitude': 15.488901520037286, 'longitude': -87.9709920029807}],
  [{'latitude': 15.514133005254607, 'longitude': -12.54436370885551},
   {'latitude': 14.493819865689165, 'longitude': -11.362022316627085},
   {'latitude': 12.368919777136181, 'longitude': -11.333774451115545}],
  [{'latitude': 15.488901520037286, 'longitude': -87.9709920029807},
   {'latitude': 15.893746216055789, 'longitude': -87.55617899908495}],
  [{'latitude': 16.28398524787876, 'longitude': -88.98151415294025},
   {'latitude': 15.895168799096593, 'longitude': -88.48615793086115},
   {'latitude': 15.488901520037286, 'longitude': -87.9709920029807}],
  [{'latitude': 16.48051506947496, 'longitude': -16.398549799914814},
   {'latitude': 16.48051506947496, 'longitude': -13.669678823202712},
   {'latitude': 15.514133005254607, 'longitude': -12.54436370885551}],
  [{'latitude': 14.27488756076215, 'longitude': -91.96305735057842},
   {'latitude': 15.959317726674481, 'longitude': -92.17403272649155},
   {'latitude': 15.959317726674481, 'longitude': -90.07363860496275},
   {'latitude': 16.316451999718712, 'longitude': -90.52930234337614},
   {'latitude': 17.874856100190016, 'longitude': -90.74700218259527},
   {'latitude': 17.874886272918005, 'longitude': -89.19901115286197}],
  [{'latitude': 17.874886272918005, 'longitude': -89.19901115286197},
   {'latitude': 16.28398524787876, 'longitude': -88.98151415294025}],
  [{'latitude': 14.246672044713124, 'longitude': 36.91344122713758},
   {'latitude': 16.3468016875165, 'longitude': 37.01875717305531},
   {'latitude': 16.96099054531793, 'longitude': 37.05281434650594},
   {'latitude': 17.967263119796467, 'longitude': 38.26740937977786}],
  [{'latitude': 17.874886272918005, 'longitude': -89.19901115286197},
   {'latitude': 18.71899165457286, 'longitude': -89.32489869335579},
   {'latitude': 18.719117678947796, 'longitude': -87.94224143442393}],
  [{'latitude': 16.561356984068567, 'longitude': 43.15771730931291},
   {'latitude': 18.923080837294602, 'longitude': 51.558523328784936}],
  [{'latitude': 18.923080837294602, 'longitude': 51.558523328784936},
   {'latitude': 16.78114501788429, 'longitude': 52.59105095411133}],
  [{'latitude': 14.989669999839558, 'longitude': 0.229350000634471},
   {'latitude': 14.99248009310932, 'longitude': 4.138196511366611},
   {'latitude': 19.04258017899977, 'longitude': 4.163981045280927}],
  [{'latitude': 10.797721182055506, 'longitude': 23.319811506593762},
   {'latitude': 11.196244940111201, 'longitude': 23.3286658676097},
   {'latitude': 12.182790705891193, 'longitude': 22.232789969902875},
   {'latitude': 14.465163454340663, 'longitude': 22.291816615832328},
   {'latitude': 15.88471165518228, 'longitude': 23.9575847184416},
   {'latitude': 19.20818463662073, 'longitude': 24.083395252790307}],
  [{'latitude': 19.5524472071304, 'longitude': 101.49583359661702},
   {'latitude': 17.775543685603875, 'longitude': 101.18626538270716},
   {'latitude': 17.765072925350797, 'longitude': 103.98446303509176},
   {'latitude': 16.580937463227272, 'longitude': 105.15100737540298},
   {'latitude': 14.592483574583564, 'longitude': 104.8612758203224}],
  [{'latitude': 20.014690263447218, 'longitude': -71.75085025130187},
   {'latitude': 18.119781329799423, 'longitude': -71.48312597600578}],
  [{'latitude': 10.03467915482904, 'longitude': 98.86189725754156},
   {'latitude': 14.145640003670719, 'longitude': 99.2899894080203},
   {'latitude': 14.57014139552314, 'longitude': 98.85775131355477},
   {'latitude': 16.111751714190206, 'longitude': 99.06552582605818},
   {'latitude': 17.385255889747455, 'longitude': 97.79447841132321},
   {'latitude': 19.574789386190826, 'longitude': 98.15479862173576},
   {'latitude': 20.535503062390465, 'longitude': 100.53903637195818}],
  [{'latitude': 20.535503062390465, 'longitude': 100.53903637195818},
   {'latitude': 19.5524472071304, 'longitude': 101.49583359661702}],
  [{'latitude': 21.13874188204622, 'longitude': 100.64711996138729},
   {'latitude': 20.535503062390465, 'longitude': 100.53903637195818}],
  [{'latitude': 19.20818463662073, 'longitude': 24.083395252790307},
   {'latitude': 19.95070298624689, 'longitude': 24.10570458356847},
   {'latitude': 19.95070298624689, 'longitude': 24.786406355867214},
   {'latitude': 21.77330129705509, 'longitude': 24.878936273537665}],
  [{'latitude': 21.77330129705509, 'longitude': 24.878936273537665},
   {'latitude': 21.773513975707388, 'longitude': 33.22915268517912}],
  [{'latitude': 21.773513975707388, 'longitude': 33.22915268517912},
   {'latitude': 21.773535855264115, 'longitude': 34.08820519509683}],
  [{'latitude': 21.773535855264115, 'longitude': 34.08820519509683},
   {'latitude': 21.773611588015385, 'longitude': 37.06164721354012}],
  [{'latitude': 22.097981230871753, 'longitude': 93.06745525329592},
   {'latitude': 20.37955420247073, 'longitude': 92.77562323976082}],
  [{'latitude': 21.96972645434016, 'longitude': 113.98770741778534},
   {'latitude': 22.145654522717145, 'longitude': 113.81920890319464},
   {'latitude': 21.987435200364306, 'longitude': 113.53351479485003},
   {'latitude': 21.811577921596378, 'longitude': 113.70214798503984}],
  [{'latitude': 23.127195771625825, 'longitude': 102.39260127547959},
   {'latitude': 22.356132860817404, 'longitude': 103.1354802629729},
   {'latitude': 20.71424049019349, 'longitude': 104.72196920984545},
   {'latitude': 19.909922063673946, 'longitude': 104.57376612455751},
   {'latitude': 19.909922063673946, 'longitude': 104.05882508722256},
   {'latitude': 19.41839413557581, 'longitude': 103.96686596700069},
   {'latitude': 16.0447251788807, 'longitude': 107.26887668615869},
   {'latitude': 14.592483574583564, 'longitude': 107.05727955661466}],
  [{'latitude': 22.330414878155835, 'longitude': 114.64016023875553},
   {'latitude': 22.50649425197523, 'longitude': 114.47201346671883},
   {'latitude': 22.340926200064704, 'longitude': 114.17228039722949},
   {'latitude': 22.164967534005267, 'longitude': 114.34067666777423}],
  [{'latitude': 18.923080837294602, 'longitude': 51.558523328784936},
   {'latitude': 18.924756462207032, 'longitude': 53.514167291476134},
   {'latitude': 20.48004115097754, 'longitude': 55.45563425313499},
   {'latitude': 21.995510845083643, 'longitude': 55.616464919602286},
   {'latitude': 22.64951469661327, 'longitude': 54.929925231247765},
   {'latitude': 22.65182600338164, 'longitude': 54.930166392387726}],
  [{'latitude': 21.13874188204622, 'longitude': 108.10421652578619},
   {'latitude': 22.03242902293603, 'longitude': 108.28080811095663},
   {'latitude': 22.03242902293603, 'longitude': 106.70424771075537},
   {'latitude': 23.127195770689614, 'longitude': 106.92487216082384}],
  [{'latitude': 23.127195771625825, 'longitude': 102.39260127547959},
   {'latitude': 21.13874188204622, 'longitude': 102.01468438351257},
   {'latitude': 21.13874188204622, 'longitude': 100.64711996138729}],
  [{'latitude': 23.127195770689614, 'longitude': 106.92487216082384},
   {'latitude': 23.127195771625825, 'longitude': 102.39260127547959}],
  [{'latitude': 23.512695998467102, 'longitude': 11.998500001150056},
   {'latitude': 23.514240017494284, 'longitude': 15.256689694806001}],
  [{'latitude': 13.77284362127625, 'longitude': 13.484058437017595},
   {'latitude': 15.316488341849139, 'longitude': 13.515648891776038},
   {'latitude': 16.65213526700406, 'longitude': 15.072396295587705},
   {'latitude': 19.408685279991367, 'longitude': 15.141231161157084},
   {'latitude': 20.2286543636108, 'longitude': 16.192558576091937},
   {'latitude': 21.113766361902364, 'longitude': 15.187668196761573},
   {'latitude': 23.514240017494284, 'longitude': 15.256689694806001}],
  [{'latitude': 23.514240017494284, 'longitude': 15.256689694806001},
   {'latitude': 23.514565691070068, 'longitude': 15.943928534074567},
   {'latitude': 19.20818463662073, 'longitude': 24.083395252790307}],
  [{'latitude': 19.04258017899977, 'longitude': 4.163981045280927},
   {'latitude': 23.896012989999342, 'longitude': 11.559930669746015}],
  [{'latitude': 23.896012989999342, 'longitude': 11.559930669746015},
   {'latitude': 23.512695998467102, 'longitude': 11.998500001150056}],
  [{'latitude': 24.551518901416635, 'longitude': 51.56417093439171},
   {'latitude': 24.25340184841843, 'longitude': 51.592380941557536},
   {'latitude': 24.122811951735844, 'longitude': 51.59145208677383},
   {'latitude': 24.08291849393848, 'longitude': 51.624807740797536},
   {'latitude': 22.935747760940263, 'longitude': 52.583352231451606},
   {'latitude': 22.65182600338164, 'longitude': 54.930166392387726}],
  [{'latitude': 22.65182600338164, 'longitude': 54.930166392387726},
   {'latitude': 24.135455481615864, 'longitude': 55.08819596970556},
   {'latitude': 24.980152643738545, 'longitude': 56.37396823373102}],
  [{'latitude': 22.097981230871753, 'longitude': 93.06745525329592},
   {'latitude': 23.4623284491083, 'longitude': 92.30000359143334},
   {'latitude': 25.026280945899583, 'longitude': 92.58809381483594},
   {'latitude': 25.026280945899583, 'longitude': 90.27441971529255}],
  [{'latitude': 24.551518901416635, 'longitude': 51.56417093439171},
   {'latitude': 25.06392876367933, 'longitude': 50.831757335457766}],
  [{'latitude': 15.514133005254607, 'longitude': -12.54436370885551},
   {'latitude': 15.498742603962649, 'longitude': -6.914051532662546},
   {'latitude': 15.498742603962649, 'longitude': -5.417510614713152},
   {'latitude': 22.03796670084714, 'longitude': -5.476802884158271},
   {'latitude': 25.223583553441102, 'longitude': -5.498822156607306}],
  [{'latitude': 25.223583553441102, 'longitude': -5.498822156607306},
   {'latitude': 19.04258017899977, 'longitude': 4.163981045280927}],
  [{'latitude': 25.026280945899583, 'longitude': 90.27441971529255},
   {'latitude': 25.741230658986044, 'longitude': 90.42580997160519},
   {'latitude': 25.741230658986044, 'longitude': 87.95201623427418},
   {'latitude': 24.691148267480894, 'longitude': 87.74459159051915},
   {'latitude': 21.469373513021345, 'longitude': 89.06318448459679}],
  [{'latitude': 25.779878978586062, 'longitude': 56.48362554893097},
   {'latitude': 25.77989658519407, 'longitude': 56.09390844914276},
   {'latitude': 26.374272931019497, 'longitude': 56.175159910143606}],
  [{'latitude': 27.081788001602405, 'longitude': 92.34449949006637},
   {'latitude': 27.082016166768522, 'longitude': 94.88992803008902},
   {'latitude': 27.082016181744702, 'longitude': 94.89009365808639}],
  [{'latitude': 27.082016181744702, 'longitude': 94.89009365808639},
   {'latitude': 24.217188298064798, 'longitude': 94.2536895376777},
   {'latitude': 24.22196251844383, 'longitude': 93.45000535161307},
   {'latitude': 22.097981230871753, 'longitude': 93.06745525329592}],
  [{'latitude': 21.336369731656212, 'longitude': -16.532859008680592},
   {'latitude': 21.325495769783192, 'longitude': -12.916529808670777},
   {'latitude': 23.158156071754245, 'longitude': -12.960780942258182},
   {'latitude': 23.158156071754245, 'longitude': -11.984651770896338},
   {'latitude': 25.23847317075813, 'longitude': -12.035002569061927},
   {'latitude': 25.783318124790995, 'longitude': -12.050515327772068},
   {'latitude': 25.783318124790995, 'longitude': -8.47095027438173},
   {'latitude': 27.100079973771678, 'longitude': -8.498244299548588}],
  [{'latitude': 27.100079973771678, 'longitude': -8.498244299548588},
   {'latitude': 25.223583553441102, 'longitude': -5.498822156607306}],
  [{'latitude': 27.807198365884034, 'longitude': -11.68983140056884},
   {'latitude': 27.81410386476266, 'longitude': -8.515346287597266}],
  [{'latitude': 27.81410386476266, 'longitude': -8.515346287597266},
   {'latitude': 27.100079973771678, 'longitude': -8.498244299548588}],
  [{'latitude': 27.89726335280399, 'longitude': 88.0565935252175},
   {'latitude': 27.908416219822385, 'longitude': 89.40199693948608}],
  [{'latitude': 27.908416219822385, 'longitude': 89.40199693948608},
   {'latitude': 26.774596281918253, 'longitude': 89.1321996639541},
   {'latitude': 26.770054567047517, 'longitude': 92.27086877217273},
   {'latitude': 27.081788001602405, 'longitude': 92.34449949006637}],
  [{'latitude': 21.13874188204622, 'longitude': 100.64711996138729},
   {'latitude': 23.752776769406125, 'longitude': 98.10876661634647},
   {'latitude': 28.042475046988, 'longitude': 99.11305434026711}],
  [{'latitude': 27.082016181744702, 'longitude': 94.89009365808639},
   {'latitude': 28.044801559463146, 'longitude': 96.9647255324277}],
  [{'latitude': 28.042475046988, 'longitude': 99.11305434026711},
   {'latitude': 28.044801559463146, 'longitude': 96.9647255324277}],
  [{'latitude': 27.89726335280399, 'longitude': 88.0565935252175},
   {'latitude': 28.17673368622131, 'longitude': 88.12468950039775},
   {'latitude': 28.17673368622131, 'longitude': 84.97784460351002},
   {'latitude': 28.17673368622131, 'longitude': 83.69943886517862}],
  [{'latitude': 28.199906729633135, 'longitude': 92.62123876794892},
   {'latitude': 28.199906729633135, 'longitude': 89.47418951728666},
   {'latitude': 27.908416219822385, 'longitude': 89.40199693948608}],
  [{'latitude': 28.199906729633135, 'longitude': 92.62123876794892},
   {'latitude': 27.081788001602405, 'longitude': 92.34449949006637}],
  [{'latitude': 28.044801559463146, 'longitude': 96.9647255324277},
   {'latitude': 29.03832463961358, 'longitude': 97.24801729257163},
   {'latitude': 29.03832463961358, 'longitude': 92.84466460911173},
   {'latitude': 28.199906729633135, 'longitude': 92.62123876794892}],
  [{'latitude': 28.556129317349818, 'longitude': 48.27614342261341},
   {'latitude': 28.556129317349818, 'longitude': 48.26204189330105},
   {'latitude': 28.556129317349818, 'longitude': 47.5496028080788},
   {'latitude': 29.224802670835004, 'longitude': 46.46248930918437}],
  [{'latitude': 29.518202342564233, 'longitude': 79.71606454070515},
   {'latitude': 26.751423238506426, 'longitude': 82.72688368966234},
   {'latitude': 26.751423238506426, 'longitude': 84.00040999762788},
   {'latitude': 26.751423238506426, 'longitude': 87.78833440285464},
   {'latitude': 27.89726335280399, 'longitude': 88.0565935252175}],
  [{'latitude': 25.676706284766063, 'longitude': 62.181113797493325},
   {'latitude': 28.340589046676282, 'longitude': 62.61411119107954},
   {'latitude': 29.960044284239597, 'longitude': 61.01683851454161}],
  [{'latitude': 29.224802670835004, 'longitude': 46.46248930918437},
   {'latitude': 29.98015590262624, 'longitude': 47.27008553242343},
   {'latitude': 29.97872698738411, 'longitude': 48.48432327557292}],
  [{'latitude': 30.17352257961669, 'longitude': 80.65437257874444},
   {'latitude': 29.518202342564233, 'longitude': 79.71606454070515}],
  [{'latitude': 28.17673368622131, 'longitude': 83.69943886517862},
   {'latitude': 30.533188587422586, 'longitude': 81.17414708858715},
   {'latitude': 30.17352257961669, 'longitude': 80.65437257874444}],
  [{'latitude': 23.896012989999342, 'longitude': 11.559930669746015},
   {'latitude': 25.792841935018487, 'longitude': 9.379402475141688},
   {'latitude': 30.82734241915985, 'longitude': 9.500044359175574}],
  [{'latitude': 28.804429595188605, 'longitude': 34.92004526558063},
   {'latitude': 31.09450617629625, 'longitude': 33.70373701002512}],
  [{'latitude': 31.35997408759738, 'longitude': 35.20657243919669},
   {'latitude': 28.804429595188605, 'longitude': 34.92004526558063}],
  [{'latitude': 31.495061873579047, 'longitude': 25.485203096424},
   {'latitude': 21.77330129705509, 'longitude': 24.878936273537665}],
  [{'latitude': 31.09450617629625, 'longitude': 33.70373701002512},
   {'latitude': 31.495061873579047, 'longitude': 33.49175178177549}],
  [{'latitude': 24.11646846121513, 'longitude': 67.79669605311365},
   {'latitude': 24.11646846121513, 'longitude': 71.11961855825768},
   {'latitude': 25.70147196521773, 'longitude': 71.36284715325274},
   {'latitude': 27.086790402123736, 'longitude': 69.98715839727409},
   {'latitude': 30.08587202776142, 'longitude': 74.42078162367984},
   {'latitude': 32.23891058917878, 'longitude': 74.95884843001974}],
  [{'latitude': 28.804429595188605, 'longitude': 34.92004526558063},
   {'latitude': 28.805715420469728, 'longitude': 36.1685122263247},
   {'latitude': 30.397330861008538, 'longitude': 38.223169257630666},
   {'latitude': 31.441495252212032, 'longitude': 37.11916488791924},
   {'latitude': 32.4556214746411, 'longitude': 39.224057767249555}],
  [{'latitude': 32.4556214746411, 'longitude': 39.224057767249555},
   {'latitude': 31.86124382961426, 'longitude': 39.498433099768526},
   {'latitude': 32.04809016187177, 'longitude': 40.40885041718155},
   {'latitude': 29.21975133405191, 'longitude': 44.75889236330211},
   {'latitude': 29.224802670835004, 'longitude': 46.46248930918437}],
  [{'latitude': 32.56560614077563, 'longitude': 35.354395566359734},
   {'latitude': 31.35997408759738, 'longitude': 35.20657243919669}],
  [{'latitude': 26.28953947306059, 'longitude': -98.03626405052925},
   {'latitude': 27.034203442942935, 'longitude': -99.07358384454429},
   {'latitude': 29.376575355649795, 'longitude': -99.72677396684463},
   {'latitude': 29.37657535471422, 'longitude': -102.25399477941082},
   {'latitude': 28.400587057752777, 'longitude': -103.10861945326275},
   {'latitude': 29.32777594010004, 'longitude': -104.47875686152787},
   {'latitude': 30.84055780062358, 'longitude': -104.97818729288949},
   {'latitude': 31.767746682970838, 'longitude': -106.4099101574359},
   {'latitude': 31.767746682970838, 'longitude': -108.03070122150149},
   {'latitude': 31.279752534958547, 'longitude': -107.84915661538108},
   {'latitude': 31.279752534958547, 'longitude': -112.52999428007733},
   {'latitude': 32.597336735154194, 'longitude': -114.62161995020978}],
  [{'latitude': 32.597336735154194, 'longitude': -114.62161995020978},
   {'latitude': 32.61212710960897, 'longitude': -117.22039619419064}],
  [{'latitude': 30.82734241915985, 'longitude': 9.500044359175574},
   {'latitude': 33.09244821733942, 'longitude': 11.455462723672936}],
  [{'latitude': 33.33529581571888, 'longitude': 35.45279791017639},
   {'latitude': 32.56560614077563, 'longitude': 35.354395566359734}],
  [{'latitude': 33.336550609938136, 'longitude': 34.4455995462296},
   {'latitude': 33.33529581571888, 'longitude': 35.45279791017639}],
  [{'latitude': 32.56560614077563, 'longitude': 35.354395566359734},
   {'latitude': 32.565083174907286, 'longitude': 36.51939386115351},
   {'latitude': 33.60674834413643, 'longitude': 38.69640226365027}],
  [{'latitude': 33.60674834413643, 'longitude': 38.69640226365027},
   {'latitude': 32.4556214746411, 'longitude': 39.224057767249555}],
  [{'latitude': 33.83801518624899, 'longitude': 77.32744738500374},
   {'latitude': 30.17352257961669, 'longitude': 80.65437257874444}],
  [{'latitude': 33.83801518624899, 'longitude': 77.32744738500374},
   {'latitude': 33.84926373081392, 'longitude': 77.34434763388099}],
  [{'latitude': 34.765923006963035, 'longitude': 36.651438140553545},
   {'latitude': 33.79819819785331, 'longitude': 36.5111570254072},
   {'latitude': 33.79833863886702, 'longitude': 35.89529856923143},
   {'latitude': 33.33529581571888, 'longitude': 35.45279791017639}],
  [{'latitude': 34.76717780118228, 'longitude': 35.8168397184478},
   {'latitude': 34.765923006963035, 'longitude': 36.651438140553545}],
  [{'latitude': 34.75849543518301, 'longitude': 76.50790894770904},
   {'latitude': 34.5273081260791, 'longitude': 76.71335649056137},
   {'latitude': 34.310027179646504, 'longitude': 76.90667950424606},
   {'latitude': 34.074639304529214, 'longitude': 77.11637349224189},
   {'latitude': 33.83801518624899, 'longitude': 77.32744738500374}],
  [{'latitude': 34.94249245758141, 'longitude': 41.52509440711064},
   {'latitude': 33.60674834413643, 'longitude': 38.69640226365027}],
  [{'latitude': 35.247481276267315, 'longitude': -1.431205489171813},
   {'latitude': 32.9647992251275, 'longitude': -1.418379836270322},
   {'latitude': 30.095978331227826, 'longitude': -4.788473131441327},
   {'latitude': 30.095978331227826, 'longitude': -7.426046409979984},
   {'latitude': 29.125641851858223, 'longitude': -8.5453740222957},
   {'latitude': 27.81410386476266, 'longitude': -8.515346287597266}],
  [{'latitude': 29.960044284239597, 'longitude': 61.01683851454161},
   {'latitude': 30.45648247722617, 'longitude': 60.529530676350056},
   {'latitude': 35.45855205267748, 'longitude': 61.66030294948131}],
  [{'latitude': 35.732927690025, 'longitude': 46.135767444411115},
   {'latitude': 33.37883268726326, 'longitude': 45.7012621342936},
   {'latitude': 33.37883268726326, 'longitude': 46.49911311953277},
   {'latitude': 32.23961141922942, 'longitude': 47.657378841685755},
   {'latitude': 31.868126222744863, 'longitude': 48.03540307198185},
   {'latitude': 30.50601383625838, 'longitude': 47.81461736768281},
   {'latitude': 29.97872698738411, 'longitude': 48.48432327557292}],
  [{'latitude': 33.84926373081392, 'longitude': 77.34434763388099},
   {'latitude': 34.82818244222662, 'longitude': 78.82680356282209},
   {'latitude': 35.06016642547606, 'longitude': 78.62338500956268},
   {'latitude': 35.28917217870835, 'longitude': 78.42253084718513},
   {'latitude': 35.524836376702574, 'longitude': 78.21607756330927},
   {'latitude': 35.74987240021678, 'longitude': 78.01915864216794},
   {'latitude': 34.75849543518301, 'longitude': 76.50790894770904}],
  [{'latitude': 36.25780415950367, 'longitude': -5.308373984417873},
   {'latitude': 36.39637213196644, 'longitude': -5.508553474006369},
   {'latitude': 36.24672041822274, 'longitude': -5.687295881535375}],
  [{'latitude': 30.82734241915985, 'longitude': 9.500044359175574},
   {'latitude': 31.192880437608608, 'longitude': 9.078937095684614},
   {'latitude': 32.71166797016862, 'longitude': 7.320054321985094},
   {'latitude': 34.01951278917153, 'longitude': 7.356559460326501},
   {'latitude': 34.863283640593764, 'longitude': 8.394225345358564},
   {'latitude': 36.73479960982384, 'longitude': 8.460759868749573}],
  [{'latitude': 29.960044284239597, 'longitude': 61.01683851454161},
   {'latitude': 29.961168882225532, 'longitude': 65.63172124079378},
   {'latitude': 33.5769581252636, 'longitude': 70.78377197837729},
   {'latitude': 35.65847715262976, 'longitude': 71.38029972187421},
   {'latitude': 35.98112203194551, 'longitude': 71.47755272773631},
   {'latitude': 36.92462402004956, 'longitude': 72.90985900120299},
   {'latitude': 36.92462402004956, 'longitude': 73.98930670427355}],
  [{'latitude': 36.92462402004956, 'longitude': 73.98930670427355},
   {'latitude': 36.92462402004956, 'longitude': 74.37910726343239}],
  [{'latitude': 34.75849543518301, 'longitude': 76.50790894770904},
   {'latitude': 35.35980253965897, 'longitude': 75.9741012734338},
   {'latitude': 36.92924283273739, 'longitude': 76.49860638323052},
   {'latitude': 36.92462402004956, 'longitude': 74.37910726343239}],
  [{'latitude': 35.45855205267748, 'longitude': 61.66030294948131},
   {'latitude': 35.459959903243856, 'longitude': 63.33560202669244},
   {'latitude': 36.94946079752391, 'longitude': 65.54083080647048}],
  [{'latitude': 36.94946079752391, 'longitude': 65.54083080647048},
   {'latitude': 36.94946079752391, 'longitude': 67.32206481159119}],
  [{'latitude': 37.446280194581036, 'longitude': 70.85592436286397},
   {'latitude': 37.446280194581036, 'longitude': 74.55264213337163}],
  [{'latitude': 36.92462402004956, 'longitude': 74.37910726343239},
   {'latitude': 37.446280194581036, 'longitude': 74.55264213337163}],
  [{'latitude': 36.478161432762825, 'longitude': 36.070586929141506},
   {'latitude': 37.54275692685965, 'longitude': 37.54040920342419},
   {'latitude': 37.54275692685965, 'longitude': 41.990434150524976}],
  [{'latitude': 37.54275692685965, 'longitude': 41.990434150524976},
   {'latitude': 34.94249245758141, 'longitude': 41.52509440711064}],
  [{'latitude': 37.54275692685965, 'longitude': 41.990434150524976},
   {'latitude': 37.54449072875082, 'longitude': 43.94673707650475}],
  [{'latitude': 37.54449072875082, 'longitude': 43.94673707650475},
   {'latitude': 37.54481038882076, 'longitude': 44.30742301113162},
   {'latitude': 35.732927690025, 'longitude': 46.135767444411115}],
  [{'latitude': 37.968112555276434, 'longitude': 50.990874471355994},
   {'latitude': 37.968112555276434, 'longitude': 52.753260929075076}],
  [{'latitude': 36.94946079752391, 'longitude': 67.32206481159119},
   {'latitude': 36.94946079752391, 'longitude': 69.07940911036913},
   {'latitude': 38.29124000659852, 'longitude': 71.13142842717913},
   {'latitude': 37.446280194581036, 'longitude': 70.85592436286397}],
  [{'latitude': 37.968112555276434, 'longitude': 52.753260929075076},
   {'latitude': 37.968112555276434, 'longitude': 54.18425848001017},
   {'latitude': 38.564708363670796, 'longitude': 55.0603551228125},
   {'latitude': 35.45855205267748, 'longitude': 61.66030294948131}],
  [{'latitude': 38.93769783949003, 'longitude': 45.53420520939799},
   {'latitude': 38.93769783949003, 'longitude': 46.56317748159859}],
  [{'latitude': 38.93769783949003, 'longitude': 46.56317748159859},
   {'latitude': 38.950132374141894, 'longitude': 48.94180924100703},
   {'latitude': 37.968112555276434, 'longitude': 49.876202695233665},
   {'latitude': 37.968112555276434, 'longitude': 50.990874471355994}],
  [{'latitude': 37.446280194581036, 'longitude': 74.55264213337163},
   {'latitude': 38.45054292631839, 'longitude': 74.89941522414522},
   {'latitude': 39.62150836538004, 'longitude': 73.88980737918084}],
  [{'latitude': 39.96349538347731, 'longitude': 69.96363774159205},
   {'latitude': 39.629905560837095, 'longitude': 69.43777457689627},
   {'latitude': 39.62150836538004, 'longitude': 73.88980737918084}],
  [{'latitude': 37.54449072875082, 'longitude': 43.94673707650475},
   {'latitude': 40.007452346480584, 'longitude': 44.464949163449766}],
  [{'latitude': 40.007452346480584, 'longitude': 44.464949163449766},
   {'latitude': 38.93769783949003, 'longitude': 45.53420520939799}],
  [{'latitude': 40.007452346480584, 'longitude': 45.49932048649188},
   {'latitude': 38.93769783949003, 'longitude': 46.56317748159859}],
  [{'latitude': 36.94946079752391, 'longitude': 67.32206481159119},
   {'latitude': 39.629258764227544, 'longitude': 68.17008660060384},
   {'latitude': 39.63035085300121, 'longitude': 68.1695020645176},
   {'latitude': 40.4194233392844, 'longitude': 69.29505458090776},
   {'latitude': 39.96349538347731, 'longitude': 69.96363774159205}],
  [{'latitude': 39.51195356245772, 'longitude': 19.431021509872505},
   {'latitude': 40.50878769616779, 'longitude': 20.73715136718705}],
  [{'latitude': 40.706366481453045, 'longitude': 51.67723816651763},
   {'latitude': 37.968112555276434, 'longitude': 50.990874471355994}],
  [{'latitude': 41.15608829947917, 'longitude': 41.546967167495175},
   {'latitude': 41.15608829947917, 'longitude': 42.31206404495618},
   {'latitude': 41.15608829947917, 'longitude': 43.71984229943822}],
  [{'latitude': 40.007452346480584, 'longitude': 44.464949163449766},
   {'latitude': 40.00745234742382, 'longitude': 43.46100052737944},
   {'latitude': 41.15608829947917, 'longitude': 43.71984229943822}],
  [{'latitude': 41.15608829947917, 'longitude': 43.71984229943822},
   {'latitude': 41.15608829947917, 'longitude': 45.77030193209791}],
  [{'latitude': 41.15608829947917, 'longitude': 45.77030193209791},
   {'latitude': 40.007452346480584, 'longitude': 45.49932048649188}],
  [{'latitude': 40.50878769616779, 'longitude': 20.73715136718705},
   {'latitude': 40.773940460261706, 'longitude': 21.08646020518196},
   {'latitude': 40.773940460261706, 'longitude': 21.670960516552146},
   {'latitude': 41.34414419490213, 'longitude': 22.435206135610038},
   {'latitude': 41.34985999908249, 'longitude': 22.94820000024006}],
  [{'latitude': 39.62150836538004, 'longitude': 73.88980737918084},
   {'latitude': 40.66250478474508, 'longitude': 74.27986390071212},
   {'latitude': 40.66250478474508, 'longitude': 77.55226002404886},
   {'latitude': 41.63484225249895, 'longitude': 79.14832855103269}],
  [{'latitude': 41.785956091542864, 'longitude': 27.009038316177314},
   {'latitude': 40.792325873225934, 'longitude': 26.866595655582753}],
  [{'latitude': 41.34985999908249, 'longitude': 22.94820000024006},
   {'latitude': 41.345573731306885, 'longitude': 25.87769742273983},
   {'latitude': 41.786528490968635, 'longitude': 26.48157662243482},
   {'latitude': 41.785956091542864, 'longitude': 27.009038316177314}],
  [{'latitude': 36.822351057042944, 'longitude': -6.993650145220265},
   {'latitude': 41.82126589875279, 'longitude': -7.166827209880904},
   {'latitude': 41.82126589875279, 'longitude': -9.40853928212971}],
  [{'latitude': 41.15608829947917, 'longitude': 45.77030193209791},
   {'latitude': 41.15608829947917, 'longitude': 46.23015425143072},
   {'latitude': 41.90563930135467, 'longitude': 46.418078133958446}],
  [{'latitude': 40.50878769616779, 'longitude': 20.73715136718705},
   {'latitude': 41.10537608816858, 'longitude': 20.806852366691935},
   {'latitude': 41.47338742419016, 'longitude': 20.39636018453696},
   {'latitude': 41.97034734044551, 'longitude': 20.45158872551567}],
  [{'latitude': 41.70767525194102, 'longitude': 12.197797034109275},
   {'latitude': 41.70767525194102, 'longitude': 12.697420896814517},
   {'latitude': 42.12016280284993, 'longitude': 12.701246254267794},
   {'latitude': 42.12143567323502, 'longitude': 12.701258169942836},
   {'latitude': 42.12143567323502, 'longitude': 12.161398477054762},
   {'latitude': 41.741549307836, 'longitude': 12.158960545007842},
   {'latitude': 41.70767525194102, 'longitude': 12.158778884540226},
   {'latitude': 41.70767525194102, 'longitude': 12.197797034109275}],
  [{'latitude': 39.96349538347731, 'longitude': 69.96363774159205},
   {'latitude': 40.91619443738694, 'longitude': 71.48086416750948},
   {'latitude': 41.67789248709086, 'longitude': 70.83623035471828},
   {'latitude': 40.7970441523527, 'longitude': 69.42925571740813},
   {'latitude': 42.20353949437843, 'longitude': 69.95033354479787}],
  [{'latitude': 42.31304949330151, 'longitude': 22.361610500831073},
   {'latitude': 41.736850175720896, 'longitude': 22.99480044040739},
   {'latitude': 41.34985999908249, 'longitude': 22.94820000024006}],
  [{'latitude': 41.97034734044551, 'longitude': 20.45158872551567},
   {'latitude': 42.31409305522191, 'longitude': 20.921799648213305},
   {'latitude': 42.31409305522191, 'longitude': 21.284483358360013},
   {'latitude': 42.31304949330151, 'longitude': 22.361610500831073}],
  [{'latitude': 42.15851690623693, 'longitude': 54.910843308828596},
   {'latitude': 41.3392433943086, 'longitude': 55.6699914313136},
   {'latitude': 41.3392433943086, 'longitude': 56.98361715062923},
   {'latitude': 42.32749269834595, 'longitude': 57.290784845453246},
   {'latitude': 42.32749269834595, 'longitude': 59.72366572075349},
   {'latitude': 39.31270040183236, 'longitude': 62.45357166022247},
   {'latitude': 39.31270040183236, 'longitude': 65.08802515067686},
   {'latitude': 38.83524946529129, 'longitude': 66.10600123773784},
   {'latitude': 36.94946079752391, 'longitude': 65.54083080647048}],
  [{'latitude': 42.456711789349974, 'longitude': 20.333313779703783},
   {'latitude': 42.4558310289676, 'longitude': 20.50623527391589},
   {'latitude': 41.97034734044551, 'longitude': 20.45158872551567}],
  [{'latitude': 41.9144924960338, 'longitude': 19.329645812606792},
   {'latitude': 42.461561319942106, 'longitude': 19.381169996434036},
   {'latitude': 42.456711789349974, 'longitude': 20.333313779703783}],
  [{'latitude': 42.59721228284872, 'longitude': 130.9032709767277},
   {'latitude': 42.598606343710344, 'longitude': 129.36317229231244},
   {'latitude': 40.02859605474802, 'longitude': 124.47615047149831},
   {'latitude': 39.66024906300433, 'longitude': 124.2486622870441}],
  [{'latitude': 41.90563930135467, 'longitude': 46.418078133958446},
   {'latitude': 41.22719661841337, 'longitude': 47.75974155056988},
   {'latitude': 42.63053591921874, 'longitude': 49.844332462359965}],
  [{'latitude': 42.63053591921874, 'longitude': 49.844332462359965},
   {'latitude': 40.706366481453045, 'longitude': 51.67723816651763}],
  [{'latitude': 41.785956091542864, 'longitude': 27.009038316177314},
   {'latitude': 42.69843618447936, 'longitude': 28.264021082465824}],
  [{'latitude': 40.706366481453045, 'longitude': 51.67723816651763},
   {'latitude': 40.968664212998014, 'longitude': 53.53665959373495},
   {'latitude': 40.968664212998014, 'longitude': 54.541841052219056},
   {'latitude': 41.856310679743544, 'longitude': 54.78980103187838},
   {'latitude': 41.850537550267006, 'longitude': 53.25667494147463},
   {'latitude': 42.13079279562457, 'longitude': 52.99430928345378},
   {'latitude': 42.92120754553855, 'longitude': 54.204120277166034},
   {'latitude': 42.15851690623693, 'longitude': 54.910843308828596}],
  [{'latitude': 43.0148835370553, 'longitude': 0.795983766763555},
   {'latitude': 42.80579196901159, 'longitude': 0.795039553908066},
   {'latitude': 42.80579196901159, 'longitude': 1.310257962871137}],
  [{'latitude': 42.80579196901159, 'longitude': 1.310257962871137},
   {'latitude': 43.0148835370553, 'longitude': 1.311814064931342}],
  [{'latitude': 43.0148835370553, 'longitude': 1.311814064931342},
   {'latitude': 43.01477678414031, 'longitude': 3.187025794690518}],
  [{'latitude': 43.18713020519833, 'longitude': 0.797768666843135},
   {'latitude': 43.0148835370553, 'longitude': 0.795983766763555}],
  [{'latitude': 43.18713020519833, 'longitude': 0.797768666843135},
   {'latitude': 43.18713020519833, 'longitude': 1.313106927915543},
   {'latitude': 43.0148835370553, 'longitude': 1.311814064931342}],
  [{'latitude': 43.21096179776425, 'longitude': 39.448698650869225},
   {'latitude': 43.21384555983208, 'longitude': 43.58761868413291},
   {'latitude': 41.90563930135467, 'longitude': 46.418078133958446}],
  [{'latitude': 42.20353949437843, 'longitude': 69.95033354479787},
   {'latitude': 42.63841445656637, 'longitude': 70.65513096781146},
   {'latitude': 42.63841445656637, 'longitude': 73.85818596432847},
   {'latitude': 43.2324308049462, 'longitude': 75.57511015701027},
   {'latitude': 43.2324308049462, 'longitude': 79.87193411905673}],
  [{'latitude': 41.63484225249895, 'longitude': 79.14832855103269},
   {'latitude': 43.2324308049462, 'longitude': 79.87193411905673}],
  [{'latitude': 43.531768984873914, 'longitude': 19.235800418669168},
   {'latitude': 43.52612004441547, 'longitude': 19.23513826260568},
   {'latitude': 42.94107836273311, 'longitude': 19.903685100812098},
   {'latitude': 42.94107836273311, 'longitude': 20.388968545152835},
   {'latitude': 42.456711789349974, 'longitude': 20.333313779703783}],
  [{'latitude': 42.651946062853064, 'longitude': 18.501661803797074},
   {'latitude': 43.531768984873914, 'longitude': 18.601889665561412},
   {'latitude': 43.531768984873914, 'longitude': 19.235800418669168}],
  [{'latitude': 43.632506283529004, 'longitude': -1.643007896865416},
   {'latitude': 43.0148835370553, 'longitude': -0.872878964389973},
   {'latitude': 43.0148835370553, 'longitude': 0.795983766763555}],
  [{'latitude': 43.70516002954041, 'longitude': 61.96403186555311},
   {'latitude': 43.70516002954041, 'longitude': 64.47953536696545},
   {'latitude': 41.13716841205379, 'longitude': 68.24334960983101},
   {'latitude': 42.20353949437843, 'longitude': 69.95033354479787}],
  [{'latitude': 43.96427408511996, 'longitude': 6.948941836325771},
   {'latitude': 43.55751204556056, 'longitude': 6.931424318737378}],
  [{'latitude': 43.96427408511996, 'longitude': 6.948941836325771},
   {'latitude': 43.96528467397994, 'longitude': 6.426792554530635},
   {'latitude': 43.557226371749564, 'longitude': 6.411437903569789}],
  [{'latitude': 42.31304949330151, 'longitude': 22.361610500831073},
   {'latitude': 42.854983564730624, 'longitude': 22.42530088963339},
   {'latitude': 43.08869760511122, 'longitude': 22.743523442308977},
   {'latitude': 43.49483411853923, 'longitude': 22.294761066153892},
   {'latitude': 44.01212526337753, 'longitude': 22.362503162553168}],
  [{'latitude': 44.01212526337753, 'longitude': 22.362503162553168},
   {'latitude': 44.012074263137954, 'longitude': 28.478596590524628}],
  [{'latitude': 44.130528801894975, 'longitude': 12.22932318814116},
   {'latitude': 43.71540959491858, 'longitude': 12.22631444619133},
   {'latitude': 43.71540959491858, 'longitude': 12.771083015404704},
   {'latitude': 44.09468282116918, 'longitude': 12.77511630681489},
   {'latitude': 44.130528801894975, 'longitude': 12.775428337912837},
   {'latitude': 44.130528801894975, 'longitude': 12.733352986106926},
   {'latitude': 44.130528801894975, 'longitude': 12.22932318814116}],
  [{'latitude': 44.86291204477175, 'longitude': 18.949584442121388},
   {'latitude': 44.86291204477175, 'longitude': 19.39438667768472},
   {'latitude': 43.531768984873914, 'longitude': 19.235800418669168}],
  [{'latitude': 43.33057564151309, 'longitude': 16.953940272577178},
   {'latitude': 44.55534183757557, 'longitude': 15.561462773288865},
   {'latitude': 45.17189781813271, 'longitude': 15.619791266393666},
   {'latitude': 45.171903901530825, 'longitude': 18.985216516950597}],
  [{'latitude': 45.171903901530825, 'longitude': 18.985216516950597},
   {'latitude': 44.86291204477175, 'longitude': 18.949584442121388}],
  [{'latitude': 42.15851690623693, 'longitude': 54.910843308828596},
   {'latitude': 45.245687509524764, 'longitude': 55.91011355970021},
   {'latitude': 45.245687509524764, 'longitude': 59.834504678045306},
   {'latitude': 43.70516002954041, 'longitude': 61.96403186555311}],
  [{'latitude': 45.39475974117031, 'longitude': 20.949501129345528},
   {'latitude': 45.39475974117031, 'longitude': 21.42651240460258},
   {'latitude': 44.67829344153791, 'longitude': 21.338730798843304},
   {'latitude': 44.677857591377474, 'longitude': 22.451986009190634},
   {'latitude': 44.01212526337753, 'longitude': 22.362503162553168}],
  [{'latitude': 45.46907608285598, 'longitude': 28.363648168561767},
   {'latitude': 45.17484434585468, 'longitude': 28.675484077583736}],
  [{'latitude': 45.171903901530825, 'longitude': 18.985216516950597},
   {'latitude': 45.96421067741815, 'longitude': 19.07708763589443}],
  [{'latitude': 45.9646920570065, 'longitude': 17.285776128715273},
   {'latitude': 45.96421067741815, 'longitude': 19.07708763589443}],
  [{'latitude': 45.96421067741815, 'longitude': 19.07708763589443},
   {'latitude': 46.23786402761459, 'longitude': 19.109153938514307},
   {'latitude': 46.23786402761459, 'longitude': 20.00624953630723}],
  [{'latitude': 46.23786402761459, 'longitude': 20.00624953630723},
   {'latitude': 45.39475974117031, 'longitude': 20.949501129345528}],
  [{'latitude': 43.96427408511996, 'longitude': 6.948941836325771},
   {'latitude': 46.237993282315635, 'longitude': 7.044637421790385}],
  [{'latitude': 46.31234555338203, 'longitude': 29.748842268635688},
   {'latitude': 46.31234555338203, 'longitude': 28.835857654983162},
   {'latitude': 45.46907608285598, 'longitude': 28.686930485915877},
   {'latitude': 45.46907608285598, 'longitude': 28.363648168561767}],
  [{'latitude': 45.53919217262831, 'longitude': 14.145738497594389},
   {'latitude': 45.543406954463215, 'longitude': 14.961885025364397},
   {'latitude': 46.051724155643534, 'longitude': 15.641963045172819},
   {'latitude': 46.44893301393415, 'longitude': 15.680537543013168},
   {'latitude': 46.44893301393415, 'longitude': 16.733685763598768}],
  [{'latitude': 46.44893301393415, 'longitude': 16.733685763598768},
   {'latitude': 45.9646920570065, 'longitude': 17.285776128715273}],
  [{'latitude': 46.547441239430896, 'longitude': 13.530421530067619},
   {'latitude': 45.53919217262831, 'longitude': 13.452207863213445}],
  [{'latitude': 46.237993282315635, 'longitude': 7.044637421790385},
   {'latitude': 46.051724155643534, 'longitude': 7.268402189767127},
   {'latitude': 46.051724155643534, 'longitude': 8.149016523273595},
   {'latitude': 46.34959180075061, 'longitude': 8.5355312025179},
   {'latitude': 46.06413064041297, 'longitude': 8.87581634335373},
   {'latitude': 46.37442466452903, 'longitude': 9.279903503929267},
   {'latitude': 46.37442466452903, 'longitude': 10.193240526363},
   {'latitude': 46.709827615540505, 'longitude': 10.214631744079902}],
  [{'latitude': 46.709827615540505, 'longitude': 10.214631744079902},
   {'latitude': 46.709827615540505, 'longitude': 13.317186737935744},
   {'latitude': 46.547441239430896, 'longitude': 13.530421530067619}],
  [{'latitude': 46.547441239430896, 'longitude': 13.530421530067619},
   {'latitude': 46.548300261530436, 'longitude': 14.605471931559027},
   {'latitude': 46.85899092858065, 'longitude': 15.022170318277658},
   {'latitude': 46.85899092858065, 'longitude': 16.264357512576172}],
  [{'latitude': 46.85899092858065, 'longitude': 16.264357512576172},
   {'latitude': 46.44893301393415, 'longitude': 16.733685763598768}],
  [{'latitude': 47.174186606578836, 'longitude': 9.939710071265585},
   {'latitude': 47.16993665443439, 'longitude': 10.244368841798702},
   {'latitude': 46.709827615540505, 'longitude': 10.214631744079902}],
  [{'latitude': 47.436731475948264, 'longitude': 9.659437269785029},
   {'latitude': 47.52792583291722, 'longitude': 9.658467925633913}],
  [{'latitude': 47.01746178410155, 'longitude': 9.940763873875664},
   {'latitude': 47.436791195357856, 'longitude': 9.937931951351606},
   {'latitude': 47.436731475948264, 'longitude': 9.659437269785029},
   {'latitude': 47.436791195357856, 'longitude': 9.38059517407399},
   {'latitude': 47.01746178410155, 'longitude': 9.38491319212184},
   {'latitude': 47.01746178410155, 'longitude': 9.940763873875664}],
  [{'latitude': 46.237993282315635, 'longitude': 7.044637421790385},
   {'latitude': 46.42409527080156, 'longitude': 6.820646607657183},
   {'latitude': 46.01450713415715, 'longitude': 6.293647583100369},
   {'latitude': 46.89629093603394, 'longitude': 6.328348624228693},
   {'latitude': 47.53095406653948, 'longitude': 7.149251280978358}],
  [{'latitude': 47.53095406653948, 'longitude': 7.149251280978358},
   {'latitude': 47.52792583291722, 'longitude': 9.658467925633913}],
  [{'latitude': 47.581960421531946, 'longitude': 26.402205767359938},
   {'latitude': 45.97753208829687, 'longitude': 28.129721405370244},
   {'latitude': 45.46907608285598, 'longitude': 28.04036585239336},
   {'latitude': 45.46907608285598, 'longitude': 28.363648168561767}],
  [{'latitude': 47.52792583291722, 'longitude': 9.658467925633913},
   {'latitude': 47.76766974044483, 'longitude': 9.674599980680512}],
  [{'latitude': 46.85899092858065, 'longitude': 16.264357512576172},
   {'latitude': 47.543409091208055, 'longitude': 16.335340863544136},
   {'latitude': 47.992063567861145, 'longitude': 16.945812184600914},
   {'latitude': 47.98893547023032, 'longitude': 17.82788836196063}],
  [{'latitude': 46.23786402761459, 'longitude': 20.00624953630723},
   {'latitude': 46.23786402761459, 'longitude': 20.702271982747504},
   {'latitude': 48.017004446491676, 'longitude': 23.17443935647992}],
  [{'latitude': 48.017004446491676, 'longitude': 23.17443935647992},
   {'latitude': 48.017004446491676, 'longitude': 25.929994341673456},
   {'latitude': 47.581960421531946, 'longitude': 26.402205767359938}],
  [{'latitude': 47.581960421531946, 'longitude': 26.402205767359938},
   {'latitude': 48.378832485502826, 'longitude': 27.54129053421196},
   {'latitude': 46.31234555338203, 'longitude': 29.748842268635688}],
  [{'latitude': 47.98893547023032, 'longitude': 17.82788836196063},
   {'latitude': 47.98857931165601, 'longitude': 19.995232659453713},
   {'latitude': 48.5161684203986, 'longitude': 20.72355009087841},
   {'latitude': 48.5161684203986, 'longitude': 22.62253873916552}],
  [{'latitude': 48.5161684203986, 'longitude': 22.62253873916552},
   {'latitude': 48.017004446491676, 'longitude': 23.17443935647992}],
  [{'latitude': 48.81128759750175, 'longitude': -123.37227822652156},
   {'latitude': 48.81128759750175, 'longitude': -121.38140392027208},
   {'latitude': 48.81128759750175, 'longitude': -91.45100532743083}],
  [{'latitude': 48.81128759750175, 'longitude': -91.45100532743083},
   {'latitude': 47.558785538759444, 'longitude': -89.13996402636681},
   {'latitude': 47.558785538759444, 'longitude': -86.82266537719036},
   {'latitude': 45.31467656702062, 'longitude': -82.837489941049},
   {'latitude': 42.29667310467618, 'longitude': -81.385174250813},
   {'latitude': 44.12498991094333, 'longitude': -79.97560836063982},
   {'latitude': 44.12498991094333, 'longitude': -76.35787346038103},
   {'latitude': 45.16553993966646, 'longitude': -75.54361272214402},
   {'latitude': 45.16553993966646, 'longitude': -71.53283834042904},
   {'latitude': 45.96161224015215, 'longitude': -70.88816703440094},
   {'latitude': 46.859193506703896, 'longitude': -70.16322838206356},
   {'latitude': 46.859193506703896, 'longitude': -68.23033298710753},
   {'latitude': 44.14122049226258, 'longitude': -67.09429509791855}],
  [{'latitude': 48.94311210775092, 'longitude': 16.737447429566654},
   {'latitude': 47.98893547023032, 'longitude': 17.82788836196063}],
  [{'latitude': 47.76766974044483, 'longitude': 9.674599980680512},
   {'latitude': 47.76766974044483, 'longitude': 12.688806421030726},
   {'latitude': 48.25402500790653, 'longitude': 12.729000708047813},
   {'latitude': 48.944477071771786, 'longitude': 13.646919927312899}],
  [{'latitude': 48.944477071771786, 'longitude': 13.646919927312899},
   {'latitude': 48.94311210775092, 'longitude': 16.737447429566654}],
  [{'latitude': 43.2324308049462, 'longitude': 79.87193411905673},
   {'latitude': 44.423894776429414, 'longitude': 80.41758852605828},
   {'latitude': 47.1618856430792, 'longitude': 84.04270423557966},
   {'latitude': 47.158613417432925, 'longitude': 85.58760551840184},
   {'latitude': 49.26812114224006, 'longitude': 86.77689983356653}],
  [{'latitude': 49.26812114224006, 'longitude': 86.77689983356653},
   {'latitude': 49.26812114224006, 'longitude': 87.21742925892325},
   {'latitude': 49.268133884777015, 'longitude': 88.06631598364885}],
  [{'latitude': 49.774150455341726, 'longitude': 7.03314756444183},
   {'latitude': 49.774150455341726, 'longitude': 6.003329637173002}],
  [{'latitude': 47.53095406653948, 'longitude': 7.149251280978358},
   {'latitude': 49.774150455341726, 'longitude': 7.255425240924707},
   {'latitude': 49.774150455341726, 'longitude': 7.03314756444183}],
  [{'latitude': 48.94311210775092, 'longitude': 16.737447429566654},
   {'latitude': 48.94275504698853, 'longitude': 17.54589198114263},
   {'latitude': 49.86104324281711, 'longitude': 18.816791906562}],
  [{'latitude': 49.86104324281711, 'longitude': 18.816791906562},
   {'latitude': 49.86104324281711, 'longitude': 21.47932479097461},
   {'latitude': 49.86104324281711, 'longitude': 22.83479607674195}],
  [{'latitude': 49.86104324281711, 'longitude': 22.83479607674195},
   {'latitude': 48.5161684203986, 'longitude': 22.62253873916552}],
  [{'latitude': 49.268133884777015, 'longitude': 88.06631598364885},
   {'latitude': 48.48357156823646, 'longitude': 87.60743088215051},
   {'latitude': 47.04100368987101, 'longitude': 91.33136132697209},
   {'latitude': 44.575934141152445, 'longitude': 89.95680457778106},
   {'latitude': 44.575934141152445, 'longitude': 94.79949945695063},
   {'latitude': 42.06772294367233, 'longitude': 96.51308064189796},
   {'latitude': 42.06772294367233, 'longitude': 108.10144061372108},
   {'latitude': 47.08156415774688, 'longitude': 117.69379829105308},
   {'latitude': 47.95466783566133, 'longitude': 117.25891271813697},
   {'latitude': 47.95466783566133, 'longitude': 115.2704797843897},
   {'latitude': 49.89081036609923, 'longitude': 116.76726626196073}],
  [{'latitude': 46.758075846125074, 'longitude': 37.656854337525075},
   {'latitude': 48.185577884844314, 'longitude': 39.798142064382844},
   {'latitude': 50.258012702645715, 'longitude': 40.35814697343783},
   {'latitude': 50.27096080897237, 'longitude': 36.59210374489518}],
  [{'latitude': 49.89081036609923, 'longitude': 116.76726626196073},
   {'latitude': 50.38289494844582, 'longitude': 117.1727666510571},
   {'latitude': 50.38289494844582, 'longitude': 113.70036681571789},
   {'latitude': 49.604857773450775, 'longitude': 112.10705166636596},
   {'latitude': 49.604857773450775, 'longitude': 108.8853625634259},
   {'latitude': 50.34182103422466, 'longitude': 108.51173645578109},
   {'latitude': 50.34182103422466, 'longitude': 102.24252655586467}],
  [{'latitude': 50.59046880994031, 'longitude': 6.034358428051381},
   {'latitude': 50.58916825711714, 'longitude': 6.034295854649143},
   {'latitude': 49.774150455341726, 'longitude': 6.003329637173002}],
  [{'latitude': 50.59046880994031, 'longitude': 6.034358428051381},
   {'latitude': 49.774150455341726, 'longitude': 7.03314756444183}],
  [{'latitude': 48.944477071771786, 'longitude': 13.646919927312899},
   {'latitude': 49.78443353239654, 'longitude': 12.662140455811038},
   {'latitude': 50.82318322712901, 'longitude': 14.071812013658631}],
  [{'latitude': 50.82318322712901, 'longitude': 14.071812013658631},
   {'latitude': 50.82318322712901, 'longitude': 17.72747529225827},
   {'latitude': 49.86104324281711, 'longitude': 18.816791906562}],
  [{'latitude': 49.774150455341726, 'longitude': 6.003329637173002},
   {'latitude': 49.774150455341726, 'longitude': 3.943693780197235},
   {'latitude': 51.25780884221144, 'longitude': 2.102038695412741}],
  [{'latitude': 49.86104324281711, 'longitude': 22.83479607674195},
   {'latitude': 50.514749414542734, 'longitude': 23.767204233169238},
   {'latitude': 51.45589959268818, 'longitude': 23.934965024218506}],
  [{'latitude': 50.34182103422466, 'longitude': 102.24252655586467},
   {'latitude': 51.6595614366222, 'longitude': 101.55899795842028},
   {'latitude': 51.6595614366222, 'longitude': 99.38798382312868},
   {'latitude': 49.66611501955519, 'longitude': 97.97236145160923},
   {'latitude': 49.66611501955519, 'longitude': 95.36815369578154},
   {'latitude': 50.62948074281805, 'longitude': 94.79587645349751},
   {'latitude': 50.62948074281805, 'longitude': 90.5644972658331},
   {'latitude': 49.7069587292339, 'longitude': 89.97844813293881},
   {'latitude': 49.7069587292339, 'longitude': 88.32779875283912},
   {'latitude': 49.268133884777015, 'longitude': 88.06631598364885}],
  [{'latitude': 51.78109113782517, 'longitude': 6.705980722974792},
   {'latitude': 51.7834912470137, 'longitude': 6.091263745297099},
   {'latitude': 50.59046880994031, 'longitude': 6.034358428051381}],
  [{'latitude': 51.82824492088386, 'longitude': 4.502984851241648},
   {'latitude': 50.59046880994031, 'longitude': 6.034358428051381}],
  [{'latitude': 51.45589959268818, 'longitude': 23.934965024218506},
   {'latitude': 51.45589959268818, 'longitude': 30.893100578043505},
   {'latitude': 52.0930730775725, 'longitude': 31.845306385655874}],
  [{'latitude': 50.27096080897237, 'longitude': 36.59210374489518},
   {'latitude': 52.0930730775725, 'longitude': 34.756591741797216},
   {'latitude': 52.0930730775725, 'longitude': 31.845306385655874}],
  [{'latitude': 53.14874125517946, 'longitude': 6.774766075266351},
   {'latitude': 51.78109113782517, 'longitude': 6.705980722974792}],
  [{'latitude': 49.89081036609923, 'longitude': 116.76726626196073},
   {'latitude': 49.89081036609923, 'longitude': 117.59362635356102},
   {'latitude': 53.441383823209925, 'longitude': 120.76373162090576},
   {'latitude': 53.441383823209925, 'longitude': 125.53731599134413}],
  [{'latitude': 53.441383823209925, 'longitude': 125.53731599134413},
   {'latitude': 47.95466783566133, 'longitude': 130.60945537679422},
   {'latitude': 47.95466783566133, 'longitude': 133.49013385773574},
   {'latitude': 48.65155188052627, 'longitude': 134.97834295446484},
   {'latitude': 47.95466783566133, 'longitude': 135.23638585784676},
   {'latitude': 44.897728978582016, 'longitude': 132.6824223203768},
   {'latitude': 45.391845133732346, 'longitude': 131.86282199726213},
   {'latitude': 44.90275836926323, 'longitude': 130.86688208196668},
   {'latitude': 43.44094969230625, 'longitude': 131.53558623744482},
   {'latitude': 42.59860634465679, 'longitude': 130.90429307325346},
   {'latitude': 42.59721228284872, 'longitude': 130.9032709767277}],
  [{'latitude': 54.0351411780751, 'longitude': -8.093132218168591},
   {'latitude': 54.03534404078541, 'longitude': -5.888243589879568}],
  [{'latitude': 54.3197891229098, 'longitude': 22.921698395862357},
   {'latitude': 54.3197891229098, 'longitude': 19.21575602028623}],
  [{'latitude': 54.3197891229098, 'longitude': 22.921698395862357},
   {'latitude': 54.3197891229098, 'longitude': 24.4741877697556}],
  [{'latitude': 54.3197891229098, 'longitude': 24.4741877697556},
   {'latitude': 51.45589959268818, 'longitude': 23.934965024218506}],
  [{'latitude': 54.3197891229098, 'longitude': 26.82796198028116},
   {'latitude': 54.3197891229098, 'longitude': 24.4741877697556}],
  [{'latitude': 50.82318322712901, 'longitude': 14.071812013658631},
   {'latitude': 54.31978912389588, 'longitude': 14.458127296106113}],
  [{'latitude': 52.0930730775725, 'longitude': 31.845306385655874},
   {'latitude': 52.967078027085755, 'longitude': 32.061218811659664},
   {'latitude': 54.398057847783214, 'longitude': 30.595377176067334}],
  [{'latitude': 54.550689526778115, 'longitude': -8.788717234927802},
   {'latitude': 54.0351411780751, 'longitude': -8.093132218168591}],
  [{'latitude': 54.554668947938396, 'longitude': 9.468533157345448},
   {'latitude': 54.554670300907645, 'longitude': 7.964715771066184}],
  [{'latitude': 55.26160763187889, 'longitude': 20.578899839125565},
   {'latitude': 55.26160763187889, 'longitude': 23.10227661075164},
   {'latitude': 54.3197891229098, 'longitude': 22.921698395862357}],
  [{'latitude': 55.31781807064968, 'longitude': 70.47237495506431},
   {'latitude': 55.31781807064968, 'longitude': 67.4961770637313},
   {'latitude': 54.353780902100866, 'longitude': 65.72569658667238},
   {'latitude': 54.353780902100866, 'longitude': 61.543168709274894},
   {'latitude': 53.905726526594144, 'longitude': 60.746045914059046},
   {'latitude': 53.45848780377138, 'longitude': 61.097575852345734},
   {'latitude': 51.266007810623144, 'longitude': 60.07661615064073},
   {'latitude': 50.571014879989214, 'longitude': 60.64899559949453},
   {'latitude': 50.571014879989214, 'longitude': 54.914104935415764},
   {'latitude': 51.2343750291857, 'longitude': 54.33991495040575},
   {'latitude': 51.2343750291857, 'longitude': 51.09840114384798},
   {'latitude': 48.81364013331207, 'longitude': 47.211713674509994},
   {'latitude': 45.96451887083773, 'longitude': 49.89302991598399},
   {'latitude': 44.6737265601567, 'longitude': 47.901023984377076},
   {'latitude': 42.63053591921874, 'longitude': 49.844332462359965}],
  [{'latitude': 49.26812114224006, 'longitude': 86.77689983356653},
   {'latitude': 49.969996421195965, 'longitude': 87.18981298211179},
   {'latitude': 49.972442454906904, 'longitude': 84.30410105977647},
   {'latitude': 51.29764462125358, 'longitude': 83.43246863485885},
   {'latitude': 51.29764462125358, 'longitude': 80.22947685557214},
   {'latitude': 54.06565208059767, 'longitude': 76.04308119542664},
   {'latitude': 53.49040647148542, 'longitude': 73.98026837874654},
   {'latitude': 53.49040647148542, 'longitude': 71.74074137092774},
   {'latitude': 55.31781807064968, 'longitude': 70.47237495506431}],
  [{'latitude': 56.17070381007273, 'longitude': 21.450056669384818},
   {'latitude': 56.17070381007273, 'longitude': 27.239853231210056}],
  [{'latitude': 56.17070381007273, 'longitude': 27.239853231210056},
   {'latitude': 54.3197891229098, 'longitude': 26.82796198028116}],
  [{'latitude': 54.398057847783214, 'longitude': 30.595377176067334},
   {'latitude': 56.17070381007273, 'longitude': 31.054729226124373},
   {'latitude': 56.17070381007273, 'longitude': 27.239853231210056}],
  [{'latitude': 57.96266039907434, 'longitude': 23.909782758174526},
   {'latitude': 57.96293586292289, 'longitude': 27.681069433236154}],
  [{'latitude': 56.17070381007273, 'longitude': 27.239853231210056},
   {'latitude': 57.96293586292289, 'longitude': 27.681069433236154}],
  [{'latitude': 57.96293586292289, 'longitude': 27.681069433236154},
   {'latitude': 59.65141374627583, 'longitude': 28.11687109677375}],
  [{'latitude': 67.86879291537736, 'longitude': -140.23530617680763},
   {'latitude': 59.946705794808096, 'longitude': -139.20128369013196},
   {'latitude': 58.88671590694047, 'longitude': -137.82115760616335},
   {'latitude': 58.88671590694047, 'longitude': -136.3835852273679},
   {'latitude': 55.899627204581236, 'longitude': -132.81211977671725},
   {'latitude': 55.899627204581236, 'longitude': -131.21220344253717},
   {'latitude': 54.55464808596354, 'longitude': -129.73930947196774},
   {'latitude': 53.68649159828478, 'longitude': -129.89934527018514}],
  [{'latitude': 60.44943256348819, 'longitude': 28.35746076977437},
   {'latitude': 61.99797712921787, 'longitude': 30.791105998224776},
   {'latitude': 63.54101671203193, 'longitude': 31.27200649194173},
   {'latitude': 63.54101671203193, 'longitude': 29.313017221835807},
   {'latitude': 65.66525544295837, 'longitude': 29.97169181067414},
   {'latitude': 67.64925724494559, 'longitude': 27.984472466200746},
   {'latitude': 68.27430917332576, 'longitude': 28.181588866700736}],
  [{'latitude': 68.99126403485435, 'longitude': 20.275384334523835},
   {'latitude': 68.62599923153363, 'longitude': 20.19075251830878},
   {'latitude': 68.62599923043112, 'longitude': 21.534758968872023},
   {'latitude': 66.6034602683952, 'longitude': 23.682832408443446},
   {'latitude': 65.67727217847352, 'longitude': 23.44726526459525}],
  [{'latitude': 58.66437298380513, 'longitude': 10.55870695999915},
   {'latitude': 59.67161437943558, 'longitude': 11.97086373593786},
   {'latitude': 63.7827199288862, 'longitude': 12.464033069522591},
   {'latitude': 63.7827199288862, 'longitude': 13.830510285867573},
   {'latitude': 65.67727217847352, 'longitude': 14.108106954326312},
   {'latitude': 67.50162867606697, 'longitude': 16.808676128900796},
   {'latitude': 68.11673909327958, 'longitude': 16.924793488882568},
   {'latitude': 68.11673909327958, 'longitude': 18.11789476885629},
   {'latitude': 68.99126999814122, 'longitude': 18.29905053625674},
   {'latitude': 68.99126403485435, 'longitude': 20.275384334523835}],
  [{'latitude': 69.4298560411133, 'longitude': -140.68808181578694},
   {'latitude': 67.86879291537736, 'longitude': -140.23530617680763}],
  [{'latitude': 68.27430917332576, 'longitude': 28.181588866700736},
   {'latitude': 70.05638835015951, 'longitude': 31.13963281068399}],
  [{'latitude': 68.99126403485435, 'longitude': 20.275384334523835},
   {'latitude': 69.17438313858061, 'longitude': 20.318076568517874},
   {'latitude': 69.17438313858061, 'longitude': 22.540011011026937},
   {'latitude': 68.26199147453012, 'longitude': 23.50148199372715},
   {'latitude': 70.24430126268207, 'longitude': 26.689089262260055},
   {'latitude': 70.24430126268207, 'longitude': 28.84128267827978},
   {'latitude': 68.27430917332576, 'longitude': 28.181588866700736}],
  [{'latitude': -2.343914328325453, 'longitude': 140.9572685091728},
   {'latitude': -9.13133299039089, 'longitude': 141.37432280520065}],
  [{'latitude': 18.133388693702273, 'longitude': -63.28213355040139},
   {'latitude': 18.122541541423164, 'longitude': -62.772978827787895}],
  [{'latitude': 6.258491061718559, 'longitude': 100.50873187736367},
   {'latitude': 6.300519188293665, 'longitude': 102.08415323477848}],
  [{'latitude': 32.23891058917878, 'longitude': 74.95884843001974},
   {'latitude': 32.78420490484692, 'longitude': 74.45436660883512}]]}
]